<template>
  <div class="flex align-items-center justify-content-center">
    <div style="width: 100%; max-width: 1600px">
      <div class="flex align-items-center justify-content-center">
        <Dropdown
          v-model="selectedPreSeason"
          :options="preSeasons"
          optionLabel="name"
          placeholder="Eine Saison wählen"
          style="margin: 10px 2px"
          @change="selectedPreSeasonChanged"
        />
        <Button
          icon="pi pi-plus"
          class="p-button-rounded mb2"
          style="margin: 5px 10px"
          @click="openNewSeasonDialog()"
        />
        <Button
          v-if="selectedPreSeason && selectedPreSeason.name"
          icon="pi pi-trash"
          class="p-button-rounded mb2"
          style="margin: 5px 10px"
          @click="openDeleteSeasonDialog()"
        />
      </div>
      <div
        v-if="selectedPreSeason && selectedPreSeason.id"
        class="flex align-items-center justify-content-center gap-2 flex-wrap"
        style="margin-bottom: 10px"
      >
        <label
          for="registrationDeadline"
          v-tooltip.top="registrationDeadlineHint"
          >Anmeldefrist (letzter Meldetag):</label
        >
        <Calendar
          inputId="registrationDeadline"
          v-model="registrationDeadlineValue"
          dateFormat="dd.mm.yy"
          showButtonBar
          :disabled="savingRegistrationDeadline"
          style="width: 150px"
        />
        <i
          class="pi pi-info-circle text-color-secondary"
          v-tooltip.top="registrationDeadlineHint"
        />
        <span v-if="registrationDeadlineExpired" class="text-color-secondary"
          >Die Mannschaftsmeldung ist geschlossen.</span
        >
      </div>
      <div v-if="savePresSeasonInProgress">
        <h3>Generiere Saison und übernehme Daten</h3>
        <h4>(das kann mehrere Minuten dauern)</h4>
        <ProgressSpinner />
      </div>
      <div v-else>
        <Stepper>
          <StepperPanel header="Ligagruppen">
            <template #content>
              <div class="flex flex-column" style="min-height: 20rem">
                <div
                  class="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium"
                >
                  <div v-if="!selectedPreSeason || !selectedPreSeason.name">
                    <h3>Keine Saison ausgewählt</h3>
                  </div>
                  <div v-else class="flex" style="width: 100%">
                    <Accordion :activeIndex="0" style="width: 100%">
                      <AccordionTab
                        v-for="preSeasonLeagueTemplate in selectedPreSeason.preSeasonLeagueTemplates"
                        :key="preSeasonLeagueTemplate.prefix"
                        :header="preSeasonLeagueTemplate.prefix"
                      >
                        <label for="numberOfLeagues">Anzahl Ligen:</label>
                        <InputNumber
                          style="margin: 10px"
                          inputClass="input-class"
                          id="numberOfLeagues"
                          v-model="preSeasonLeagueTemplate.numberOfLeagues"
                          inputId="integeronly"
                          @input="numberOfLeaguesChanged(preSeasonLeagueTemplate)"
                          showButtons
                          buttonLayout="horizontal"
                          ><template #incrementbuttonicon>
                            <span class="pi pi-plus" />
                          </template>
                          <template #decrementbuttonicon>
                            <span class="pi pi-minus" />
                          </template>
                        </InputNumber>
                        <div class="flex align-items-center gap-2 mt-2 flex-wrap">
                          <!-- Der Tooltip haengt bewusst an Label und Symbol, NICHT am Dropdown: PrimeVue loest
                               bei einem p-inputwrapper auf dessen inneres input auf, das es beim beforeMount der
                               Direktive noch nicht gibt (Fehler "Cannot set properties of null"). -->
                          <label
                            :for="'dateChoice' + preSeasonLeagueTemplate.id"
                            v-tooltip.top="dateChoiceHint(preSeasonLeagueTemplate)"
                            >Spieltermine:</label
                          >
                          <Dropdown
                            :inputId="'dateChoice' + preSeasonLeagueTemplate.id"
                            v-model="preSeasonLeagueTemplate.freeDateChoice"
                            :options="dateChoiceOptions"
                            optionLabel="label"
                            optionValue="value"
                            style="min-width: 320px"
                            @change="saveLeagueTemplate(preSeasonLeagueTemplate)"
                          />
                          <i
                            class="pi pi-info-circle text-color-secondary"
                            v-tooltip.top="dateChoiceHint(preSeasonLeagueTemplate)"
                          />
                        </div>
                        <div class="flex align-items-center gap-3 mt-3 flex-wrap">
                          <label
                            :for="'promotionCount' + preSeasonLeagueTemplate.id"
                            v-tooltip.top="promotionHint"
                            >Aufstiegsplätze:</label
                          >
                          <InputNumber
                            :inputId="'promotionCount' + preSeasonLeagueTemplate.id"
                            v-model="preSeasonLeagueTemplate.promotionCount"
                            :min="0"
                            :max="20"
                            inputStyle="width: 60px"
                            showButtons
                            buttonLayout="horizontal"
                            @input="saveLeagueTemplate(preSeasonLeagueTemplate)"
                          >
                            <template #incrementbuttonicon><span class="pi pi-plus" /></template>
                            <template #decrementbuttonicon><span class="pi pi-minus" /></template>
                          </InputNumber>
                          <label
                            :for="'promotionPlayoffCount' + preSeasonLeagueTemplate.id"
                            v-tooltip.top="promotionHint"
                            >Relegationsplätze:</label
                          >
                          <InputNumber
                            :inputId="'promotionPlayoffCount' + preSeasonLeagueTemplate.id"
                            v-model="preSeasonLeagueTemplate.promotionPlayoffCount"
                            :min="0"
                            :max="20"
                            inputStyle="width: 60px"
                            showButtons
                            buttonLayout="horizontal"
                            @input="saveLeagueTemplate(preSeasonLeagueTemplate)"
                          >
                            <template #incrementbuttonicon><span class="pi pi-plus" /></template>
                            <template #decrementbuttonicon><span class="pi pi-minus" /></template>
                          </InputNumber>
                          <label
                            :for="'relegationCount' + preSeasonLeagueTemplate.id"
                            v-tooltip.top="promotionHint"
                            >Abstiegsplätze:</label
                          >
                          <InputNumber
                            :inputId="'relegationCount' + preSeasonLeagueTemplate.id"
                            v-model="preSeasonLeagueTemplate.relegationCount"
                            :min="0"
                            :max="20"
                            inputStyle="width: 60px"
                            showButtons
                            buttonLayout="horizontal"
                            @input="saveLeagueTemplate(preSeasonLeagueTemplate)"
                          >
                            <template #incrementbuttonicon><span class="pi pi-plus" /></template>
                            <template #decrementbuttonicon><span class="pi pi-minus" /></template>
                          </InputNumber>
                          <i class="pi pi-info-circle text-color-secondary" v-tooltip.top="promotionHint" />
                        </div>
                      </AccordionTab>
                    </Accordion>
                  </div>
                </div>
                <div
                  v-if="selectedPreSeason && selectedPreSeason.name"
                  class="flex justify-content-center"
                  style="margin-top: 10px"
                >
                  <Button
                    label="Ligagruppe hinzufügen"
                    icon="pi pi-plus"
                    class="p-button-sm"
                    @click="openAddLeagueTemplateDialog()"
                  />
                </div>
              </div>
            </template>
          </StepperPanel>
          <StepperPanel header="Mannschaften">
            <div style="max-width: 1000px; width: 100%">
              <div
                class="flex flex-wrap align-items-center gap-2"
                style="margin-top: 10px"
              >
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="teamSearchTerm"
                    placeholder="Mannschaft suchen (Teil des Namens)"
                    style="min-width: 300px"
                  />
                </span>
                <Button
                  v-if="teamSearchTerm && teamSearchTerm.length > 0"
                  class="p-button-text p-button-sm"
                  label="Suche löschen"
                  icon="pi pi-times"
                  @click="teamSearchTerm = ''"
                />
                <span class="text-color-secondary"
                  >{{ searchedTeams.length }} / {{ allTeams.length }} Mannschaften</span
                >
                <Button
                  class="p-button-sm p-button-outlined"
                  style="margin-left: auto"
                  icon="pi pi-file-excel"
                  label="Boardabnahme-Liste"
                  :loading="boardInspectionExportRunning"
                  :disabled="!selectedPreSeason || !selectedPreSeason.id"
                  v-tooltip.top="
                    'Excel-Liste der Spielorte, die eine Boardabnahme brauchen: neue Spielorte und Spielorte mit geänderter Board-Anzahl'
                  "
                  @click="exportBoardInspectionList()"
                />
              </div>
              <DataTable
                class="p-datatable-sm"
                :value="searchedTeams"
                stripedRows
                responsiveLayout="stack"
                breakpoint="550px"
                style="margin-top: 10px"
              >
                <template #empty>
                  Keine Mannschaft für die aktuelle Suche gefunden.
                </template>
                <Column header="Name" field="name" />
                <Column header="Ligatyp">
                  <template #body="{ data }">
                    <Tag
                      v-if="data.leagueTemplatePrefix"
                      severity="info"
                      :value="data.leagueTemplatePrefix"
                    />
                    <Tag v-else severity="warning" value="Nicht zugewiesen" />
                  </template>
                </Column>
                <Column header="Basiert auf">
                  <template #body="{ data }">
                    <Tag
                      v-if="data.existingTeamName"
                      severity="info"
                      :value="data.existingTeamName"
                      v-tooltip.top="'Mannschaft der laufenden Saison'"
                    />
                    <Tag v-else severity="success" value="Neue Mannschaft" />
                  </template>
                </Column>
                <Column header="Spielort">
                  <template #body="{ data }">
                    <div v-if="data.locationName" class="flex flex-column gap-1">
                      <span>{{ data.locationName }}</span>
                      <Tag
                        :severity="data.locationUsedInSeason ? 'info' : 'success'"
                        :value="
                          data.locationUsedInSeason
                            ? 'Datensatz der Saison'
                            : 'Neuer Datensatz'
                        "
                        style="align-self: flex-start"
                      />
                    </div>
                    <span v-else>-</span>
                  </template>
                </Column>
                <Column header="Ansprechpartner">
                  <template #body="{ data }">
                    <div v-if="data.contactPersonName" class="flex flex-column gap-1">
                      <span>{{ data.contactPersonName }}</span>
                      <Tag
                        :severity="data.contactPersonUsedInSeason ? 'info' : 'success'"
                        :value="
                          data.contactPersonUsedInSeason
                            ? 'Datensatz der Saison'
                            : 'Neuer Datensatz'
                        "
                        style="align-self: flex-start"
                      />
                    </div>
                    <span v-else>-</span>
                  </template>
                </Column>
                <Column header="Aktionen">
                  <template #body="slotProps">
                    <Button
                      style="margin: 2px 2px"
                      icon="pi pi-pencil"
                      v-tooltip.top="'Editieren'"
                      class="p-button-rounded p-button-success mb2"
                      @click="editTeam(slotProps.data)"
                    />
                    <Button
                      style="margin: 2px 2px"
                      icon="pi pi-trash"
                      v-tooltip.top="'Löschen'"
                      class="p-button-rounded p-button-danger"
                      @click="deleteTeam(slotProps.data)"
                    />
                  </template>
                </Column>
              </DataTable>
            </div>
          </StepperPanel>
          <StepperPanel header="Mannschaften zu Ligagruppen">
            <template #content>
              <div class="flex flex-column" style="width: 100%; min-height: 12rem">
                <div
                  class="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium"
                  style="width: 100%"
                >
                  <div v-if="!selectedPreSeason || !selectedPreSeason.name">
                    <h3>Keine Saison ausgewählt</h3>
                  </div>
                  <div v-else style="width: 100%">
                    <div
                      class="flex-none flex align-items-center justify-content-center"
                      style="width: 100%; height: 100%"
                    >
                      <Dropdown
                        v-model="selectedPreSeasonLeagueTemplate"
                        :options="selectedPreSeason.preSeasonLeagueTemplates"
                        optionLabel="prefix"
                        placeholder="Eine Ligagruppe wählen"
                        @change="selectedLeagueTemplateChanged"
                        style="width: 280px"
                      ></Dropdown>
                    </div>
                    <div
                      class="flex-none flex align-items-center justify-content-center gap-2 flex-wrap"
                      style="width: 100%; margin: 8px 0"
                    >
                      <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText
                          v-model="teamsPickListSearchTerm"
                          placeholder="Mannschaft suchen (Teil des Namens)"
                          style="min-width: 300px"
                        />
                      </span>
                      <Button
                        v-if="teamsPickListSearchTerm && teamsPickListSearchTerm.length > 0"
                        class="p-button-text p-button-sm"
                        label="Suche löschen"
                        icon="pi pi-times"
                        @click="teamsPickListSearchTerm = ''"
                      />
                      <Button
                        class="p-button-sm p-button-outlined"
                        icon="pi pi-sitemap"
                        label="Übrige nach aktueller Liga einteilen"
                        :loading="assigningByCurrentLeague"
                        @click="assignRemainingTeamsByCurrentLeague()"
                      />
                      <Button
                        class="p-button-sm p-button-outlined"
                        icon="pi pi-check-square"
                        label="Einteilung prüfen"
                        :loading="checkingAssignment"
                        v-tooltip.top="
                          'Prüft die aktuelle Einteilung anhand der Platzierungen der Vorsaison sowie der Aufstiegs-, Relegations- und Abstiegsplätze, die in der Vorsaison für die jeweilige Liga galten'
                        "
                        @click="checkTeamAssignmentByCurrentLeague()"
                      />
                      <span class="text-color-secondary"
                        >{{ assignedTeamCount }} von {{ preSeasonTeamCount }} Mannschaften in
                        Ligagruppen</span
                      >
                    </div>
                    <div
                      class="flex-grow-1 flex align-items-center justify-content-center gap-2"
                      style="width: 100%; height: 100%"
                    >
                      <PickList
                        v-if="teamsPickList && teamsPickList.length >= 2"
                        :modelValue="filteredTeamsPickList"
                        v-model:selection="teamsPickListSelection"
                        dataKey="id"
                        :showSourceControls="false"
                        :showTargetControls="false"
                        @move-to-target="movedInPickList($event, true)"
                        @move-all-to-target="movedInPickList($event, true)"
                        @move-to-source="movedInPickList($event, false)"
                        @move-all-to-source="movedInPickList($event, false)"
                        style="width: 100%"
                        ><template #sourceheader>
                          Verfügbar ({{ pickListCountLabel(0) }})</template
                        >
                        <template #targetheader>
                          In der Liga ({{ pickListCountLabel(1) }})</template
                        >
                        <template #item="slotProps">
                          <span class="font-bold">{{ slotProps.item.name }}</span>
                        </template></PickList
                      >
                      <div
                        v-if="teamsPickList && teamsPickList.length >= 2"
                        class="flex flex-column gap-2"
                      >
                        <span v-tooltip.left="moveUpHint">
                          <Button
                            icon="pi pi-angle-double-up"
                            class="p-button-rounded"
                            :disabled="!canMoveSelectedTeams(-1) || movingTeams"
                            @click="moveSelectedTeams(-1)"
                          />
                        </span>
                        <span v-tooltip.left="moveDownHint">
                          <Button
                            icon="pi pi-angle-double-down"
                            class="p-button-rounded"
                            :disabled="!canMoveSelectedTeams(1) || movingTeams"
                            @click="moveSelectedTeams(1)"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </StepperPanel>

          <StepperPanel header="Bedingungen / Wünsche">
            <template #content>
              <div class="flex flex-column h-12rem">
                <div
                  class="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium"
                >
                  <div v-if="!selectedPreSeason || !selectedPreSeason.name">
                    <h3>Keine Saison ausgewählt</h3>
                  </div>
                  <div v-else class="flex" style="width: 100%">
                    <div class="flex-none flex flex-column gap-2 border-round">
                      <Dropdown
                        v-model="teamFilter"
                        :options="teamFilterOptions"
                        optionLabel="label"
                        optionValue="value"
                        style="width: 100%"
                      />
                      <Listbox
                        v-model="selectedTeam"
                        :options="filteredTeams"
                        optionLabel="name"
                        listStyle="max-height: calc(100vh - 14rem)"
                        @change="selectedTeamChanged"
                      ></Listbox>
                    </div>
                    <div
                      class="flex-grow-1 flex align-items-start justify-content-center border-round"
                      style="
                        position: sticky;
                        top: 1rem;
                        align-self: flex-start;
                        max-height: calc(100vh - 2rem);
                        overflow-y: auto;
                      "
                    >
                      <div
                        v-if="selectedTeam && selectedTeam.id"
                        class="flex flex-column"
                        style="width: 100%"
                      >
                        <div
                          class="flex align-items-center justify-content-center border-round m-2"
                        >
                          <Button
                            label="Bedingung oder Wunsch hinzufügen"
                            icon="pi pi-plus"
                            @click="addCriteria"
                          />
                        </div>
                        <div
                          v-if="selectedTeamCriteriaNotes"
                          class="surface-card border-round p-3 m-2"
                          style="text-align: left"
                        >
                          <div class="font-bold mb-1">
                            <i class="pi pi-pencil" style="margin-right: 6px"></i>
                            Freitext aus der Meldung
                          </div>
                          <div class="text-color-secondary mb-2" style="font-size: 0.85em">
                            Wird von der Spielplanerstellung NICHT ausgewertet – bei Bedarf
                            oben als Bedingung erfassen.
                          </div>
                          <div style="white-space: pre-wrap">
                            {{ selectedTeamCriteriaNotes }}
                          </div>
                        </div>
                        <div class="flex align-items-center justify-content-center">
                          <DataTable
                            class="p-datatable-sm"
                            :value="teamCriterias"
                            stripedRows
                            responsiveLayout="stack"
                            breakpoint="550px"
                            style="margin-top: 15px; width: 100%"
                          >
                            <Column field="type" header="Art">
                              <template #body="{ data }">
                                <span>{{ getLabelForCriteriaType(data) }}</span>
                              </template>
                            </Column>
                            <!-- <Column field="priority" header="Priorität"></Column>-->
                            <Column header="Aktionen" style="width: 100px">
                              <template #body="slotProps">
                                <Button
                                  style="margin: 2px 2px"
                                  icon="pi pi-pencil"
                                  v-tooltip.top="'Editieren'"
                                  class="p-button-rounded p-button-success mb2"
                                  @click="editCriteria(slotProps.data)"
                                />
                                <Button
                                  style="margin: 2px 2px"
                                  icon="pi pi-trash"
                                  v-tooltip.top="'Löschen'"
                                  class="p-button-rounded p-button-warning"
                                  @click="deleteCriteria(slotProps.data)"
                                />
                              </template>
                            </Column>
                          </DataTable>
                        </div>
                      </div>
                      <div v-else>
                        <h3>Keine Mannschaft ausgewählt</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </StepperPanel>

          <StepperPanel header="Spieltage">
            <template #content>
              <div class="flex flex-column h-12rem">
                <div
                  class="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium"
                >
                  <div v-if="!selectedPreSeason || !selectedPreSeason.name">
                    <h3>Keine Saison ausgewählt</h3>
                  </div>
                  <div v-else class="flex flex-column" style="width: 100%">
                    <div
                      class="flex align-items-center justify-content-center"
                      style="width: 100%"
                    >
                      <div
                        class="flex justify-content-center flex-wrap"
                        style="width: 100%"
                      >
                        <div
                          class="flex align-items-center justify-content-center"
                          style="width: 100%"
                        >
                          <label for="firstScheduleStart"
                            >Beginn der Saison für die 1. Liga-Gruppe:</label
                          >
                          <Calendar
                            style="margin: 10px"
                            v-model="firstScheduleStart"
                            inputId="firstScheduleStart"
                            dateFormat="dd.mm.yy"
                          />
                        </div>
                        <div
                          class="flex align-items-center justify-content-center"
                          style="width: 100%"
                        >
                          <label for="secondScheduleStart"
                            >Beginn der Saison für die 2. Liga-Gruppe:</label
                          >
                          <Calendar
                            style="margin: 10px"
                            v-model="secondScheduleStart"
                            inputId="secondScheduleStart"
                            dateFormat="dd.mm.yy"
                          />
                        </div>
                        <div>
                          <Button
                            label="Spieltage erstellen"
                            @click="updateScheduleStart(true)"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="flex flex-column align-items-center"
                      style="width: 100%; margin-top: 10px"
                    >
                      <div class="flex align-items-center justify-content-center gap-2 flex-wrap">
                        <label for="blockedDate">Kein Spieltag am:</label>
                        <Calendar
                          inputId="blockedDate"
                          v-model="newBlockedDate.dateValue"
                          dateFormat="dd.mm.yy"
                          style="width: 150px"
                        />
                        <InputText
                          v-model="newBlockedDate.reason"
                          placeholder="Grund (optional)"
                          style="width: 220px"
                        />
                        <Button
                          label="Sperrtermin hinzufügen"
                          icon="pi pi-plus"
                          class="p-button-sm"
                          :disabled="!newBlockedDate.dateValue || savingBlockedDates"
                          @click="addBlockedDate()"
                        />
                      </div>
                      <div
                        v-if="blockedDates.length"
                        class="flex align-items-center justify-content-center gap-2 flex-wrap"
                        style="margin-top: 8px"
                      >
                        <Tag
                          v-for="blockedDate in blockedDates"
                          :key="blockedDate.date"
                          severity="warning"
                          style="cursor: pointer"
                          v-tooltip.top="'Sperrtermin entfernen'"
                          @click="removeBlockedDate(blockedDate)"
                        >
                          {{ blockedDate.label
                          }}<span v-if="blockedDate.reason"> – {{ blockedDate.reason }}</span>
                          <i class="pi pi-times" style="margin-left: 6px" />
                        </Tag>
                      </div>
                      <div class="text-color-secondary" style="margin-top: 6px">
                        Sperrtermine wirken beim Erstellen der Spieltage: der Spieltag rückt auf
                        den Tag davor.
                      </div>
                    </div>
                    <div
                      v-if="gameDays && gameDays.length > 0"
                      class="flex align-items-center justify-content-center"
                    >
                      <DataTable
                        class="p-datatable-sm"
                        :value="gameDays"
                        :rowStyle="gameDayRowStyle"
                        stripedRows
                        responsiveLayout="stack"
                        breakpoint="550px"
                        style="margin-top: 15px; width: 100%"
                      >
                        <Column field="number" header="Spieltag" />
                        <Column field="group" header="Gruppe" style="width: 80px" />
                        <Column field="dateString" header="Datum" />
                        <Column header="Kalenderwoche" style="width: 150px">
                          <template #body="slotProps">
                            KW {{ slotProps.data.calendarWeek }} ({{
                              slotProps.data.weekTypeLabel
                            }})
                          </template>
                        </Column>
                        <Column field="moveCause" header="Verschoben wegen" />
                        <Column header="Aktionen" style="width: 190px">
                          <template #body="slotProps">
                            <Button
                              style="margin: 2px 2px"
                              icon="pi pi-angle-double-left"
                              v-tooltip.top="'Einen Termin früher, gleiche Kalenderwochen-Parität (Folgetermine ziehen mit)'"
                              class="p-button-rounded p-button-secondary"
                              :disabled="shiftingGameDay"
                              @click="shiftGameDay(slotProps.data, -1)"
                            />
                            <Button
                              style="margin: 2px 2px"
                              icon="pi pi-angle-double-right"
                              v-tooltip.top="'Einen Termin später, gleiche Kalenderwochen-Parität (Folgetermine ziehen mit)'"
                              class="p-button-rounded p-button-secondary"
                              :disabled="shiftingGameDay"
                              @click="shiftGameDay(slotProps.data, 1)"
                            />
                            <Button
                              style="margin: 2px 2px"
                              icon="pi pi-calendar"
                              v-tooltip.top="'Verschieben'"
                              class="p-button-rounded p-button-success"
                              @click="changeGameDay(slotProps.data)"
                            />
                          </template>
                        </Column>
                      </DataTable>
                    </div>
                    <div v-else>
                      <h4>Beginn der beiden Gruppen bestimmen</h4>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </StepperPanel>
          <StepperPanel header="Spielplan">
            <template #content>
              <div class="flex flex-column h-12rem">
                <div
                  class="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium"
                >
                  <div v-if="!selectedPreSeason || !selectedPreSeason.name">
                    <h3>Keine Saison ausgewählt</h3>
                  </div>
                  <div v-else class="flex flex-column" style="width: 100%">
                    <div
                      v-if="
                        !scheduleCalculationStatus ||
                        (scheduleCalculationStatus.status !== 'RUNNING' &&
                          scheduleCalculationStatus.status !== 'CANCELING')
                      "
                      class="flex align-items-center justify-content-center gap-3 mb-3 flex-wrap"
                      style="width: 100%"
                    >
                      <label for="distWeight" class="font-bold"
                        >Gewicht Reise-Distanz:</label
                      >
                      <Slider
                        id="distWeight"
                        v-model="distanceWeight"
                        :min="1"
                        :max="10"
                        style="width: 220px"
                      />
                      <span><b>{{ distanceWeight }}</b> / 10</span>
                    </div>
                    <div
                      v-if="
                        bestKnownStart &&
                        bestKnownStart.available &&
                        (!scheduleCalculationStatus ||
                          (scheduleCalculationStatus.status !== 'RUNNING' &&
                            scheduleCalculationStatus.status !== 'CANCELING'))
                      "
                      class="flex align-items-center justify-content-center gap-2 mb-3 flex-wrap"
                      style="width: 100%"
                    >
                      <Checkbox
                        id="useBestKnownStart"
                        v-model="useBestKnownStart"
                        :binary="true"
                      />
                      <label for="useBestKnownStart"
                        >Auf dem bisher besten Plan weiterrechnen</label
                      >
                      <Tag
                        :severity="bestKnownStart.hardScore === 0 ? 'success' : 'warning'"
                        :value="bestKnownStartLabel"
                      />
                      <Button
                        icon="pi pi-check"
                        label="Als Ligeneinteilung übernehmen"
                        class="p-button-sm p-button-outlined"
                        :loading="applyingBestKnownStart"
                        @click="applyBestKnownStart()"
                      />
                      <Button
                        icon="pi pi-trash"
                        label="Verwerfen"
                        class="p-button-text p-button-sm"
                        @click="discardBestKnownStart()"
                      />
                    </div>
                    <div
                      class="flex align-items-center justify-content-center"
                      style="width: 100%"
                    >
                      <Button
                        v-if="
                          scheduleCalculationStatus &&
                          scheduleCalculationStatus.status == 'RUNNING'
                        "
                        style="margin: 2px 2px"
                        icon="pi pi-stop"
                        label="Berechnung des Spielplans stoppen"
                        class="p-button-rounded p-button-success mb2"
                        @click="changeScheduleCalculationStatus('cancel')"
                      />
                      <Button
                        v-else-if="
                          scheduleCalculationStatus &&
                          scheduleCalculationStatus.status == 'FINISHED'
                        "
                        style="margin: 2px 2px"
                        icon="pi pi-play"
                        label="Berechnung des Spielplans neu starten"
                        class="p-button-rounded p-button-success mb2"
                        @click="changeScheduleCalculationStatus('start')"
                      />
                      <Button
                        v-else-if="
                          scheduleCalculationStatus &&
                          scheduleCalculationStatus.status == 'CANCELING'
                        "
                        style="margin: 2px 2px"
                        icon="pi pi-clock"
                        label="Warten auf das Ergebnis"
                        class="p-button-rounded p-button-success mb2"
                        disabled
                      />
                      <Button
                        v-else
                        style="margin: 2px 2px"
                        icon="pi pi-play"
                        label="Berechnung des Spielplans neu starten"
                        class="p-button-rounded p-button-success mb2"
                        @click="changeScheduleCalculationStatus('start')"
                      />
                      <Button
                        v-if="
                          scheduleCalculationStatus &&
                          scheduleCalculationStatus.status == 'FINISHED'
                        "
                        style="margin: 2px 2px"
                        icon="pi pi-arrow-right"
                        label="Spielplan in Saison übernehmen"
                        class="p-button-rounded p-button-warning mb2"
                        :loading="loadingSeasonTransferPreview"
                        @click="openSeasonTransferDialog"
                      />
                    </div>
                    <div
                      v-if="scheduleCalculationStatus && scheduleCalculationStatus.status"
                      class="flex align-items-center justify-content-center"
                      style="width: 100%"
                    >
                      <div class="flex flex-column">
                        <div
                          class="flex align-items-center justify-content-center m-2 p-2 border-round"
                        >
                          <ProgressSpinner
                            v-if="
                              scheduleCalculationStatus.status === 'RUNNING' ||
                              scheduleCalculationStatus.status === 'CANCELING'
                            "
                            style="width: 24px; height: 24px; margin-right: 10px"
                            strokeWidth="6"
                          />
                          <span>{{
                            scheduleStatusLabel(scheduleCalculationStatus.status)
                          }}</span>
                        </div>
                        <div
                          v-if="scheduleCalculationStatus.errorMessage"
                          class="m-2 p-3 border-round"
                          style="
                            width: 100%;
                            max-width: 560px;
                            text-align: left;
                            border: 1px solid var(--red-400);
                          "
                        >
                          <div class="font-bold mb-2" style="color: var(--red-600)">
                            <i class="pi pi-times-circle" style="margin-right: 6px"></i>
                            {{ scheduleCalculationStatus.errorMessage }}
                          </div>
                          <ul
                            v-if="
                              scheduleCalculationStatus.errorDetails &&
                              scheduleCalculationStatus.errorDetails.length
                            "
                            style="margin: 0; padding-left: 18px"
                          >
                            <li
                              v-for="(detail, index) in scheduleCalculationStatus.errorDetails"
                              :key="index"
                            >
                              {{ detail }}
                            </li>
                          </ul>
                        </div>
                        <div
                          v-if="distancePreparation"
                          class="m-2 p-3 border-round surface-100"
                          style="width: 100%; max-width: 560px; text-align: left"
                        >
                          <div class="font-bold mb-2">
                            <i class="pi pi-map-marker" style="margin-right: 6px"></i>
                            Koordinaten und Entfernungen der Spielorte
                          </div>
                          <div v-if="distancePreparation.running">
                            <div class="mb-2">
                              <span v-if="distancePreparation.step">
                                {{ distancePreparation.step }} –
                                {{ distancePreparation.done }} von
                                {{ distancePreparation.total }} ermittelt
                              </span>
                              <span v-else>Spielorte werden geprüft …</span>
                            </div>
                            <ProgressBar :value="distancePreparationPercent" />
                          </div>
                          <div v-else>
                            <div
                              v-if="
                                !distancePreparation.missingCoordinates &&
                                !distancePreparation.missingDistances
                              "
                            >
                              Alle {{ distancePreparation.locationCount }} Spielorte hatten
                              bereits Koordinaten, für alle
                              {{ distancePreparation.distancePairCount }} Ortspaare lag eine
                              gefahrene Strecke vor.
                            </div>
                            <div v-else>
                              {{ distancePreparation.locationCount }} Spielorte,
                              {{ distancePreparation.distancePairCount }} Ortspaare geprüft.
                              Neu ermittelt:
                              {{ distancePreparation.resolvedCoordinates }} von
                              {{ distancePreparation.missingCoordinates }} fehlenden
                              Koordinaten und
                              {{ distancePreparation.resolvedDistances }} von
                              {{ distancePreparation.missingDistances }} fehlenden
                              Fahrstrecken.
                            </div>
                          </div>
                          <div
                            v-if="
                              distancePreparation.locationsWithoutCoordinates &&
                              distancePreparation.locationsWithoutCoordinates.length
                            "
                            class="mt-2"
                            style="color: var(--red-600)"
                          >
                            <div class="font-bold">
                              Ohne Koordinaten – eine Spielplan-Erstellung ist damit nicht
                              möglich:
                            </div>
                            <ul style="margin: 0; padding-left: 18px">
                              <li
                                v-for="(location, index) in distancePreparation.locationsWithoutCoordinates"
                                :key="index"
                              >
                                {{ location }}
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="flex flex-column align-items-center justify-content-center m-2 p-2 border-round"
                        >
                          <div
                            v-if="
                              (scheduleCalculationStatus.status === 'RUNNING' ||
                                scheduleCalculationStatus.status === 'CANCELING') &&
                              scheduleCalculationStatus.scoreCalculationsPerSecond
                            "
                            style="margin-bottom: 12px"
                          >
                            <i class="pi pi-bolt" style="margin-right: 6px"></i>
                            <span
                              >Getestete Kombinationen:
                              {{
                                formatNumber(
                                  scheduleCalculationStatus.numberOfCombinationsChecked
                                )
                              }}
                              ({{
                                formatNumber(
                                  scheduleCalculationStatus.scoreCalculationsPerSecond
                                )
                              }}
                              pro Sekunde)</span
                            >
                          </div>
                          <div
                            v-if="!(distancePreparation && distancePreparation.running)"
                            style="margin-bottom: 20px"
                          >
                            <span
                              >Bewertung des besten Spielplans (0 = zulässiger Plan, je
                              niedriger desto besser):
                              {{
                                scheduleCalculationStatus.currentBestValidationResult
                              }}</span
                            >
                          </div>
                          <div
                            v-for="validationMessage in scheduleCalculationStatus.validationMessages"
                            v-bind:key="validationMessage"
                          >
                            {{ validationMessage }}
                          </div>
                          <div
                            v-if="
                              scheduleCalculationStatus.softViolations &&
                              scheduleCalculationStatus.softViolations.length
                            "
                            class="mt-3"
                            style="width: 100%; max-width: 560px"
                          >
                            <div class="font-bold mb-2">
                              Weiche Verstöße (Details, kleiner = besser)
                            </div>
                            <table style="width: 100%; border-collapse: collapse">
                              <thead>
                                <tr>
                                  <th
                                    style="
                                      text-align: left;
                                      padding: 4px 8px;
                                      border-bottom: 2px solid var(--surface-border);
                                    "
                                  >
                                    Kategorie
                                  </th>
                                  <th
                                    style="
                                      text-align: right;
                                      padding: 4px 8px;
                                      border-bottom: 2px solid var(--surface-border);
                                    "
                                  >
                                    Wert
                                  </th>
                                  <th
                                    style="
                                      text-align: right;
                                      padding: 4px 8px;
                                      border-bottom: 2px solid var(--surface-border);
                                    "
                                  >
                                    Veränderung
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="sv in scheduleCalculationStatus.softViolations"
                                  :key="sv.name"
                                >
                                  <td
                                    style="
                                      text-align: left;
                                      padding: 2px 8px;
                                      border-bottom: 1px solid var(--surface-border);
                                    "
                                  >
                                    {{ sv.name }}
                                  </td>
                                  <td
                                    style="
                                      text-align: right;
                                      padding: 2px 8px;
                                      border-bottom: 1px solid var(--surface-border);
                                    "
                                  >
                                    {{ sv.value }}
                                  </td>
                                  <td
                                    style="
                                      text-align: right;
                                      padding: 2px 8px;
                                      border-bottom: 1px solid var(--surface-border);
                                      white-space: nowrap;
                                    "
                                  >
                                    <span
                                      v-if="
                                        softDeltas[sv.name] !== undefined &&
                                        softDeltas[sv.name] !== 0
                                      "
                                      :style="deltaStyle(softDeltas[sv.name])"
                                    >
                                      {{ deltaLabel(softDeltas[sv.name]) }}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div
                            v-if="
                              scheduleCalculationStatus.unfulfilledWishes &&
                              scheduleCalculationStatus.unfulfilledWishes.length
                            "
                            class="mt-3"
                            style="width: 100%; max-width: 560px"
                          >
                            <div class="font-bold mb-2">
                              Nicht erfüllte Wünsche ({{
                                scheduleCalculationStatus.unfulfilledWishes.length
                              }})
                            </div>
                            <ul style="margin: 0; padding-left: 18px; text-align: left">
                              <li
                                v-for="(wish, index) in scheduleCalculationStatus.unfulfilledWishes"
                                :key="index"
                                style="margin-bottom: 2px"
                              >
                                {{ wish }}
                              </li>
                            </ul>
                          </div>
                          <div
                            v-else-if="
                              scheduleCalculationStatus.softViolations &&
                              scheduleCalculationStatus.softViolations.length
                            "
                            class="mt-3 font-italic"
                            style="text-align: left"
                          >
                            Alle Wünsche der Mannschaften konnten erfüllt werden.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="scheduleReport"
                      class="surface-card p-3 border-round"
                      style="width: 100%; margin-top: 15px; text-align: left"
                    >
                      <div
                        class="flex flex-wrap align-items-center justify-content-between gap-2 mb-3"
                      >
                        <div class="font-bold text-xl">{{ scheduleReport.title }}</div>
                        <Button
                          icon="pi pi-copy"
                          :label="reportCopied ? 'Kopiert' : 'Bericht kopieren'"
                          class="p-button-rounded p-button-sm p-button-secondary"
                          @click="copyScheduleReport"
                        />
                      </div>
                      <p
                        v-for="(paragraph, index) in scheduleReport.paragraphs"
                        :key="index"
                        style="margin: 0 0 12px 0; line-height: 1.6"
                      >
                        {{ paragraph }}
                      </p>
                      <div v-if="scheduleReport.wishBreakdown.length" class="mt-3">
                        <div class="font-bold mb-2">Die Wünsche im Einzelnen</div>
                        <ul style="margin: 0; padding-left: 18px">
                          <li
                            v-for="(line, index) in scheduleReport.wishBreakdown"
                            :key="index"
                            style="margin-bottom: 2px"
                          >
                            {{ line }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div style="width: 100%; margin-top: 15px" v-if="resultLeagues.length">
                      <!-- Liga-Typ-Auswahl: Heatmap + weiche Verstöße werden pro Liga-Typ geladen -->
                      <div class="flex flex-wrap align-items-center gap-2 mb-3">
                        <label class="font-bold">Liga-Typ:</label>
                        <Dropdown
                          v-model="selectedTier"
                          :options="resultTiers"
                          placeholder="Liga-Typ wählen"
                          @change="onTierChange"
                          style="min-width: 160px"
                        />
                        <ProgressSpinner
                          v-if="loadingTierResult"
                          style="width: 20px; height: 20px"
                          strokeWidth="6"
                        />
                      </div>

                      <div
                        v-if="tierResult"
                        class="flex flex-wrap gap-3 align-items-start mb-4"
                      >
                        <!-- Heatmap des Liga-Typs (alle Ligen des Tiers) -->
                        <div
                          class="surface-card p-3 border-round"
                          style="flex: 1 1 320px; min-width: 300px; max-width: 480px"
                        >
                          <div class="font-bold mb-2">
                            Heatmap – alle {{ selectedTier }}-Ligen
                          </div>
                          <div style="position: relative; width: 100%">
                            <img
                              v-if="tierResult.heatMapImage"
                              :src="tierResult.heatMapImage"
                              style="
                                width: 100%;
                                height: auto;
                                display: block;
                                border-radius: 6px;
                                border: 1px solid var(--surface-border);
                              "
                            />
                            <template v-if="tierResult.imageWidth > 0">
                              <div
                                v-for="group in tierHeatMapGroups"
                                :key="group.key"
                                class="heatmap-hotspot"
                                :style="{
                                  position: 'absolute',
                                  left:
                                    (group.x / tierResult.imageWidth) * 100 + '%',
                                  top:
                                    (group.y / tierResult.imageHeight) * 100 + '%',
                                  transform: 'translate(-50%, -50%)',
                                  width: '16px',
                                  height: '16px',
                                  borderRadius: '50%',
                                  background: 'transparent',
                                  cursor: 'pointer',
                                }"
                                @mouseenter="hoveredHeatMapLocation = group"
                                @mouseleave="hoveredHeatMapLocation = null"
                                @click="selectedHeatMapLocation = group"
                              />
                            </template>
                            <div
                              v-if="activeHeatMapLocation"
                              class="surface-card p-2 border-round shadow-3"
                              :style="{
                                position: 'absolute',
                                top: '8px',
                                right: '8px',
                                maxWidth: '75%',
                                zIndex: 5,
                                border: '1px solid var(--surface-border)',
                                pointerEvents: isHeatMapPinned ? 'auto' : 'none',
                              }"
                            >
                              <div
                                class="flex align-items-center justify-content-between mb-1 gap-2"
                              >
                                <span class="font-bold">
                                  Mannschaften hier
                                  <span
                                    v-if="isHeatMapPinned"
                                    class="text-color-secondary"
                                    style="font-weight: normal"
                                    >· angeheftet</span
                                  >
                                </span>
                                <Button
                                  v-if="isHeatMapPinned"
                                  icon="pi pi-times"
                                  class="p-button-text p-button-sm"
                                  @click="selectedHeatMapLocation = null"
                                />
                              </div>
                              <div
                                v-for="t in activeHeatMapLocation.teams"
                                :key="t.teamName + '/' + t.leagueName"
                              >
                                {{ t.teamName }}
                                <span class="text-color-secondary"
                                  >({{ t.leagueName }})</span
                                >
                              </div>
                              <div
                                v-if="!isHeatMapPinned"
                                class="text-color-secondary mt-1"
                                style="font-size: 0.8rem"
                              >
                                Klicken zum Anheften
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Weiche Verstöße des Liga-Typs (alle Mannschaften) -->
                        <div
                          class="surface-card p-3 border-round"
                          style="flex: 2 1 360px; min-width: 320px"
                        >
                          <div class="font-bold mb-2">
                            Weiche Verstöße – alle {{ selectedTier }}-Mannschaften
                          </div>
                          <table
                            v-if="tierResult.softViolations.length"
                            style="width: 100%; border-collapse: collapse"
                          >
                            <tr v-for="sv in tierResult.softViolations" :key="sv.name">
                              <td
                                style="
                                  text-align: left;
                                  padding: 2px 8px;
                                  border-bottom: 1px solid var(--surface-border);
                                "
                              >
                                {{ sv.name }}
                              </td>
                              <td
                                style="
                                  text-align: right;
                                  padding: 2px 8px;
                                  border-bottom: 1px solid var(--surface-border);
                                "
                              >
                                {{ sv.value }}
                              </td>
                            </tr>
                          </table>
                          <div v-else class="text-color-secondary">
                            Keine weichen Verstöße.
                          </div>
                          <div
                            v-if="tierResult.softViolationsPerTeam.length"
                            class="mt-3"
                          >
                            <div class="mb-2">
                              Ø Reise-Distanz je Mannschaft:
                              <b>{{ averageDistanceRounded }} km</b>
                              <span class="text-color-secondary">
                                – Distanz-Spalte relativ zum Durchschnitt eingefärbt</span
                              >
                            </div>
                            <div style="overflow-x: auto; width: 100%">
                              <table style="border-collapse: collapse; width: 100%">
                                <thead>
                                  <tr>
                                    <th
                                      style="
                                        text-align: left;
                                        padding: 4px 8px;
                                        border-bottom: 2px solid var(--surface-border);
                                      "
                                    >
                                      Mannschaft
                                    </th>
                                    <th
                                      style="
                                        text-align: center;
                                        padding: 4px 8px;
                                        border-bottom: 2px solid var(--surface-border);
                                        font-size: 0.82rem;
                                        vertical-align: bottom;
                                      "
                                    >
                                      KW-Wunsch
                                    </th>
                                    <th
                                      style="
                                        text-align: center;
                                        padding: 4px 8px;
                                        border-bottom: 2px solid var(--surface-border);
                                        font-size: 0.82rem;
                                        vertical-align: bottom;
                                      "
                                    >
                                      Liga-Woche
                                    </th>
                                    <th
                                      v-for="cat in tierCategories"
                                      :key="cat"
                                      style="
                                        text-align: center;
                                        padding: 4px 8px;
                                        border-bottom: 2px solid var(--surface-border);
                                        font-size: 0.82rem;
                                        vertical-align: bottom;
                                        min-width: 90px;
                                      "
                                    >
                                      {{ cat }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template
                                    v-for="group in tierTeamsByLeague"
                                    :key="group.leagueName"
                                  >
                                    <tr>
                                      <td
                                        :colspan="tierCategories.length + 3"
                                        style="
                                          text-align: left;
                                          padding: 6px 8px;
                                          border-bottom: 1px solid var(--surface-border);
                                          background: var(--surface-100);
                                          font-weight: 700;
                                        "
                                      >
                                        <span
                                          :style="{
                                            display: 'inline-block',
                                            width: '12px',
                                            height: '12px',
                                            borderRadius: '2px',
                                            marginRight: '6px',
                                            verticalAlign: 'middle',
                                            background: group.color
                                              ? 'rgb(' +
                                                group.color.red +
                                                ',' +
                                                group.color.green +
                                                ',' +
                                                group.color.blue +
                                                ')'
                                              : 'transparent',
                                            border: '1px solid var(--surface-border)',
                                          }"
                                        ></span>
                                        {{ group.leagueName }}
                                      </td>
                                    </tr>
                                    <tr
                                      v-for="team in group.teams"
                                      :key="group.leagueName + '/' + team.teamName"
                                    >
                                      <td
                                        style="
                                          text-align: left;
                                          padding: 2px 8px;
                                          border-bottom: 1px solid var(--surface-border);
                                          white-space: nowrap;
                                        "
                                      >
                                        <Button
                                          icon="pi pi-sync"
                                          class="p-button-text p-button-sm p-button-rounded mr-1"
                                          v-tooltip.top="'Liga tauschen'"
                                          @click="openSwapDialog(team)"
                                        />
                                        {{ team.teamName }}
                                      </td>
                                      <td
                                        style="
                                          text-align: center;
                                          padding: 2px 8px;
                                          border-bottom: 1px solid var(--surface-border);
                                        "
                                      >
                                        {{ weekLabel(team.weekTypeWish) }}
                                      </td>
                                      <td
                                        style="
                                          text-align: center;
                                          padding: 2px 8px;
                                          border-bottom: 1px solid var(--surface-border);
                                        "
                                      >
                                        {{ weekLabel(team.leagueWeekType) }}
                                      </td>
                                      <td
                                        v-for="cat in tierCategories"
                                        :key="cat"
                                        :style="softCellStyle(cat, team)"
                                      >
                                        {{ valueForTeam(team, cat) }}
                                      </td>
                                    </tr>
                                  </template>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Liga-Auswahl: Spielplan wird pro Liga (lazy) geladen -->
                      <div class="flex align-items-center gap-2 mb-2">
                        <label class="font-bold">Liga:</label>
                        <Dropdown
                          v-model="selectedResultLeague"
                          :options="leaguesOfSelectedTier"
                          optionLabel="name"
                          placeholder="Liga wählen"
                          @change="onResultLeagueChange"
                          style="min-width: 200px"
                        />
                        <ProgressSpinner
                          v-if="loadingLeagueResult"
                          style="width: 20px; height: 20px"
                          strokeWidth="6"
                        />
                      </div>

                      <div
                        v-if="selectedLeagueResult"
                        class="surface-card p-3 border-round"
                        style="width: 100%"
                      >
                        <div class="font-bold mb-2">
                          Spielplan {{ selectedLeagueResult.leagueName }}
                        </div>
                        <DataTable
                          class="p-datatable-sm"
                          :value="selectedLeagueResult.games"
                          stripedRows
                          sortMode="multiple"
                          responsiveLayout="stack"
                          style="width: 100%"
                        >
                          <Column field="gameDayNumber" header="Spieltag" sortable />
                          <Column field="date" header="Datum" sortable />
                          <Column field="homeTeam" header="Heim" sortable />
                          <Column field="guestTeam" header="Gast" sortable />
                          <Column field="location" header="Spielort" sortable />
                          <Column
                            field="gamesAtLocationOnDate"
                            header="Spiele am Ort (Tag)"
                            sortable
                          >
                            <template #body="slotProps">
                              <span :style="boardLoadStyle(slotProps.data)">
                                {{ slotProps.data.gamesAtLocationOnDate }} Spiel(e) –
                                {{ slotProps.data.gamesAtLocationOnDate * 2 }}/{{
                                  slotProps.data.boards
                                }}
                                Boards
                              </span>
                            </template>
                          </Column>
                          <Column
                            field="distanceForGuestTeam"
                            header="Anfahrt in km"
                            sortable
                          />
                        </DataTable>
                      </div>

                      <div
                        v-if="resultUnfulfilledWishes.length"
                        class="surface-card p-3 border-round mt-3"
                        style="width: 100%"
                      >
                        <div class="font-bold mb-2">
                          Nicht erfüllte Wünsche ({{ resultUnfulfilledWishCount }})
                        </div>
                        <div class="text-color-secondary mb-3" style="font-size: 0.9em">
                          Wünsche, die der Plan verletzt, sowie Wünsche, die gar nicht
                          ausgewertet werden konnten (z. B. unbekannte Mannschaft).
                        </div>
                        <div
                          v-for="group in resultUnfulfilledWishes"
                          :key="group.team"
                          class="mb-2"
                        >
                          <div class="font-bold">{{ group.team || "Ohne Mannschaft" }}</div>
                          <ul style="margin: 2px 0 0 0; padding-left: 18px">
                            <li
                              v-for="(wish, index) in group.wishes"
                              :key="index"
                              style="margin-bottom: 2px"
                            >
                              {{ wish }}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div
                        v-else-if="resultLeagues.length"
                        class="surface-card p-3 border-round mt-3 font-italic"
                        style="width: 100%"
                      >
                        Alle Wünsche der Mannschaften konnten erfüllt werden.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </StepperPanel>
        </Stepper>
      </div>
    </div>
  </div>
  <Dialog
    id="newSeasonDialog"
    modal
    v-model:visible="displayNewSeasonDialog"
    :closable="true"
  >
    <template #header>
      <div
        class="align-items-center justify-content-center"
        style="font-size: 20px; text-align: center; width: 100%"
      >
        Neue Saison erstellen
      </div>
    </template>
    <div class="flex flex-column">
      <label for="name" class="col-fixed" style="width: 100%"
        >Name der neuen Saison:</label
      >
      <InputText id="name" v-model="selectedPreSeason.name" />
      <label for="season" class="col-fixed" style="width: 100%"
        >Existierende Saison als Vorlage:</label
      >
      <Dropdown
        id="season"
        v-model="selectedSeason"
        :options="seasons"
        optionLabel="name"
        placeholder="Eine Saison wählen"
        style="margin: 10px 2px"
      />
    </div>
    <template #footer>
      <div class="flex justify-content-between flex-wrap card-container">
        <Button label="Abbrechen" @click="closeNewSeasonDialog(false)" />
        <Button label="Speichern" @click="closeNewSeasonDialog(true)" />
      </div>
    </template>
  </Dialog>
  <Dialog id="deleteSeasonDialog" modal v-model:visible="displayDeleteSeasonDialog">
    <template #header>
      <div
        class="align-items-center justify-content-center"
        style="font-size: 20px; text-align: center; width: 100%"
      >
        Saison löschen?
      </div>
    </template>
    <div class="flex flex-column">
      Möchten Sie wirklich die Saison "{{ selectedPreSeason.name }}" löschen
    </div>
    <template #footer>
      <div class="flex justify-content-between flex-wrap card-container">
        <Button label="Abbrechen" @click="closeDeleteSeasonDialog(false)" />
        <Button label="Löschen" @click="closeDeleteSeasonDialog(true)" />
      </div>
    </template>
  </Dialog>
  <Dialog
    id="criteriaDialog"
    modal
    v-model:visible="displayCriteriaDialog"
    :closable="true"
  >
    <template #header>
      <div
        class="align-items-center justify-content-center"
        style="font-size: 20px; text-align: center; width: 100%"
      >
        Bedingung / Wunsch bearbeiten
      </div>
    </template>
    <div class="flex flex-column">
      <div class="flex align-items-center justify-content-center">
        <Dropdown
          v-model="selectedTeamCriteriaFieldDescription"
          :options="currentTeamPreSeasonTeamCriteriaFieldDescriptions"
          optionLabel="label"
          placeholder="Bedingung / Wunsch auswählen"
          style="width: 350px"
          @change="selectedTeamCriteriaFieldDescriptionChanged()"
        ></Dropdown>
      </div>
      <div
        v-if="
          selectedTeamCriteriaFieldDescription &&
          selectedTeamCriteriaFieldDescription.type
        "
        class="flex flex-column align-items-center justify-content-center"
      >
        <!--
        <div class="flex flex-column" style="margin: 20px; width: 300px">
          <label>Priorität (je höher desto wichtiger)</label>
          <InputNumber v-model="currentTeamCriteria.priority" :min="1" :max="1000" />
          <Slider v-model="currentTeamCriteria.priority" :min="1" :max="1000" />
        </div>
        -->
        <div class="flex flex-column">
          <div
            class="flex align-items-center justify-content-center"
            v-for="recordFieldDescription in selectedTeamCriteriaFieldDescription.fieldDescriptions"
            v-bind:key="recordFieldDescription.name + ':' + Math.random()"
          >
            <RecordField
              v-model:record="currentTeamCriteria"
              :recordFieldDescription="recordFieldDescription"
              :editMode="true"
              :minWidth="300"
            />
          </div>
        </div>
      </div>
      <div v-else></div>
    </div>
    <template #footer>
      <div class="flex justify-content-between flex-wrap card-container">
        <Button label="Abbrechen" @click="closeCriteriaDialog(false)" />
        <Button label="Speichern" @click="closeCriteriaDialog(true)" />
      </div>
    </template>
  </Dialog>
  <Dialog v-model:visible="showAddLeagueTemplateDialog" :closable="false">
    <template #header>
      <h3>Ligagruppe hinzufügen</h3>
    </template>
    <div class="flex flex-column" style="min-width: 340px">
      <div class="flex align-items-center gap-2" style="margin-bottom: 12px">
        <label for="newLeagueTemplatePrefix" style="min-width: 130px">Kürzel:</label>
        <AutoComplete
          id="newLeagueTemplatePrefix"
          v-model="newLeagueTemplate.prefix"
          :suggestions="filteredLeagueTemplatePrefixes"
          :dropdown="true"
          :completeOnFocus="true"
          inputStyle="width: 180px"
          @complete="filterLeagueTemplatePrefixes"
        />
      </div>
      <div class="flex align-items-center gap-2" style="margin-bottom: 12px">
        <label for="newLeagueTemplateCount" style="min-width: 130px">Anzahl Ligen:</label>
        <InputNumber
          id="newLeagueTemplateCount"
          v-model="newLeagueTemplate.numberOfLeagues"
          :min="1"
          :max="30"
          showButtons
          buttonLayout="horizontal"
          inputStyle="width: 60px"
        >
          <template #incrementbuttonicon><span class="pi pi-plus" /></template>
          <template #decrementbuttonicon><span class="pi pi-minus" /></template>
        </InputNumber>
      </div>
      <div class="flex align-items-center gap-2" style="margin-bottom: 12px">
        <label for="newLeagueTemplateDateChoice" style="min-width: 130px">Spieltermine:</label>
        <Dropdown
          inputId="newLeagueTemplateDateChoice"
          v-model="newLeagueTemplate.freeDateChoice"
          :options="dateChoiceOptions"
          optionLabel="label"
          optionValue="value"
          style="min-width: 320px"
        />
      </div>
      <div class="flex align-items-center gap-2" style="margin-bottom: 12px">
        <label for="newLeagueTemplatePromotion" style="min-width: 130px" v-tooltip.top="promotionHint"
          >Aufstiegsplätze:</label
        >
        <InputNumber
          inputId="newLeagueTemplatePromotion"
          v-model="newLeagueTemplate.promotionCount"
          :min="0"
          :max="20"
          showButtons
          buttonLayout="horizontal"
          inputStyle="width: 60px"
        >
          <template #incrementbuttonicon><span class="pi pi-plus" /></template>
          <template #decrementbuttonicon><span class="pi pi-minus" /></template>
        </InputNumber>
      </div>
      <div class="flex align-items-center gap-2" style="margin-bottom: 12px">
        <label
          for="newLeagueTemplatePromotionPlayoff"
          style="min-width: 130px"
          v-tooltip.top="promotionHint"
          >Relegationsplätze:</label
        >
        <InputNumber
          inputId="newLeagueTemplatePromotionPlayoff"
          v-model="newLeagueTemplate.promotionPlayoffCount"
          :min="0"
          :max="20"
          showButtons
          buttonLayout="horizontal"
          inputStyle="width: 60px"
        >
          <template #incrementbuttonicon><span class="pi pi-plus" /></template>
          <template #decrementbuttonicon><span class="pi pi-minus" /></template>
        </InputNumber>
      </div>
      <div class="flex align-items-center gap-2">
        <label for="newLeagueTemplateRelegation" style="min-width: 130px" v-tooltip.top="promotionHint"
          >Abstiegsplätze:</label
        >
        <InputNumber
          inputId="newLeagueTemplateRelegation"
          v-model="newLeagueTemplate.relegationCount"
          :min="0"
          :max="20"
          showButtons
          buttonLayout="horizontal"
          inputStyle="width: 60px"
        >
          <template #incrementbuttonicon><span class="pi pi-plus" /></template>
          <template #decrementbuttonicon><span class="pi pi-minus" /></template>
        </InputNumber>
      </div>
      <Message
        v-if="addLeagueTemplateError"
        severity="error"
        :closable="false"
        style="margin-top: 12px"
        >{{ addLeagueTemplateError }}</Message
      >
      <div class="text-color-secondary" style="margin-top: 12px; max-width: 460px">
        Eigene Kürzel sind erlaubt. Sie werden in der Übersicht hinter den bekannten
        Spielklassen (OL, BZO, BZ, KBZ, KL) einsortiert und bei der Vereins-Trennung wie die
        Kreisliga gewichtet.
      </div>
    </div>
    <template #footer>
      <Button
        label="Abbrechen"
        class="p-button-text"
        @click="closeAddLeagueTemplateDialog(false)"
      />
      <Button
        label="Hinzufügen"
        icon="pi pi-check"
        :disabled="addingLeagueTemplate"
        @click="closeAddLeagueTemplateDialog(true)"
      />
    </template>
  </Dialog>
  <Dialog v-model:visible="showAssignByLeagueDialog" :closable="false">
    <template #header>
      <h3>Einteilung nach aktueller Liga</h3>
    </template>
    <div style="max-width: 620px">
      <p>
        {{ assignByLeagueResult.assigned || 0 }} Mannschaft(en) anhand ihrer Liga in der
        laufenden Saison eingeteilt, davon {{ assignByLeagueResult.promoted || 0 }}
        Aufsteiger eine Ligagruppe höher und {{ assignByLeagueResult.relegated || 0 }}
        Absteiger eine tiefer.
      </p>
      <ul v-if="assignByLeagueSummary.length" style="padding-left: 18px">
        <li v-for="(entry, index) in assignByLeagueSummary" :key="index">
          {{ entry }}
        </li>
      </ul>
      <div
        v-if="assignByLeagueResult.openDecisions && assignByLeagueResult.openDecisions.length"
        style="margin-top: 12px"
      >
        <div class="font-bold">
          Bitte prüfen ({{ assignByLeagueResult.openDecisions.length }}):
        </div>
        <ul style="padding-left: 18px">
          <li
            v-for="(entry, index) in assignByLeagueResult.openDecisions"
            :key="index"
            style="margin-bottom: 2px"
          >
            {{ entry }}
          </li>
        </ul>
      </div>
      <div
        v-if="assignByLeagueResult.notAssigned && assignByLeagueResult.notAssigned.length"
        style="margin-top: 12px"
      >
        <div class="font-bold">
          Nicht eingeteilt ({{ assignByLeagueResult.notAssigned.length }}):
        </div>
        <ul style="padding-left: 18px">
          <li
            v-for="(team, index) in assignByLeagueResult.notAssigned"
            :key="index"
            style="margin-bottom: 2px"
          >
            {{ team }}
          </li>
        </ul>
      </div>
    </div>
    <template #footer>
      <Button
        label="Schließen"
        icon="pi pi-check"
        @click="showAssignByLeagueDialog = false"
      />
    </template>
  </Dialog>
  <Dialog v-model:visible="showCheckAssignmentDialog" :closable="false">
    <template #header>
      <h3>Prüfung der Einteilung</h3>
    </template>
    <div style="max-width: 700px">
      <p>
        {{ checkAssignmentResult.correct || 0 }} von
        {{ checkAssignmentResult.checked || 0 }} geprüften Mannschaften sind anhand ihrer
        Platzierung und der Auf- und Abstiegsregelung der Vorsaison richtig eingeteilt.
      </p>
      <div
        v-if="
          checkAssignmentResult.wrongAssignments &&
          checkAssignmentResult.wrongAssignments.length
        "
        style="margin-top: 12px"
      >
        <div class="font-bold">
          Falsch eingeteilt ({{ checkAssignmentResult.wrongAssignments.length }}):
        </div>
        <ul style="padding-left: 18px">
          <li
            v-for="(entry, index) in checkAssignmentResult.wrongAssignments"
            :key="index"
            style="margin-bottom: 2px"
          >
            {{ entry }}
          </li>
        </ul>
      </div>
      <div
        v-if="
          checkAssignmentResult.relegationPassed &&
          checkAssignmentResult.relegationPassed.length
        "
        style="margin-top: 12px"
      >
        <div class="font-bold">
          Relegation wohl geschafft ({{
            checkAssignmentResult.relegationPassed.length
          }}):
        </div>
        <ul style="padding-left: 18px">
          <li
            v-for="(entry, index) in checkAssignmentResult.relegationPassed"
            :key="index"
            style="margin-bottom: 2px"
          >
            {{ entry }}
          </li>
        </ul>
      </div>
      <div
        v-if="
          checkAssignmentResult.relegationFailed &&
          checkAssignmentResult.relegationFailed.length
        "
        style="margin-top: 12px"
      >
        <div class="font-bold">
          Relegation wohl nicht geschafft ({{
            checkAssignmentResult.relegationFailed.length
          }}):
        </div>
        <ul style="padding-left: 18px">
          <li
            v-for="(entry, index) in checkAssignmentResult.relegationFailed"
            :key="index"
            style="margin-bottom: 2px"
          >
            {{ entry }}
          </li>
        </ul>
      </div>
      <div
        v-if="checkAssignmentResult.hints && checkAssignmentResult.hints.length"
        style="margin-top: 12px"
      >
        <div class="font-bold">Hinweise ({{ checkAssignmentResult.hints.length }}):</div>
        <ul style="padding-left: 18px">
          <li
            v-for="(entry, index) in checkAssignmentResult.hints"
            :key="index"
            style="margin-bottom: 2px"
          >
            {{ entry }}
          </li>
        </ul>
      </div>
      <div
        v-if="checkAssignmentResult.notChecked && checkAssignmentResult.notChecked.length"
        style="margin-top: 12px"
      >
        <div class="font-bold">
          Nicht prüfbar ({{ checkAssignmentResult.notChecked.length }}):
        </div>
        <ul style="padding-left: 18px">
          <li
            v-for="(entry, index) in checkAssignmentResult.notChecked"
            :key="index"
            style="margin-bottom: 2px"
          >
            {{ entry }}
          </li>
        </ul>
      </div>
    </div>
    <template #footer>
      <Button
        label="Schließen"
        icon="pi pi-check"
        @click="showCheckAssignmentDialog = false"
      />
    </template>
  </Dialog>
  <Dialog v-model:visible="showSeasonTransferDialog" :closable="false">
    <template #header>
      <h3>Spielplan in Saison übernehmen</h3>
    </template>
    <div style="max-width: 640px">
      <p>
        Der berechnete Spielplan wird als Saison
        <b>{{ seasonTransferPreview.seasonName }}</b> angelegt:
        {{ seasonTransferPreview.leagueCount }} Ligen,
        {{ seasonTransferPreview.gameDayCount }} Spieltage,
        {{ seasonTransferPreview.gameCount }} Spiele (davon
        {{ seasonTransferPreview.byeGameCount }} spielfrei) und
        {{ seasonTransferPreview.teamCount }} Mannschaften (davon
        {{ seasonTransferPreview.newTeamCount }} neu angelegt).
      </p>
      <div
        v-if="seasonTransferPreview.seasonExists"
        class="p-3 border-round"
        style="background: var(--red-100); color: var(--red-900)"
      >
        Es gibt bereits eine Saison
        <b>{{ seasonTransferPreview.seasonName }}</b> mit
        {{ seasonTransferPreview.existingLeagueCount }} Ligen und
        {{ seasonTransferPreview.existingGameCount }} Spielen (davon
        {{ seasonTransferPreview.existingGamesWithResultCount }} mit Ergebnis). Sie wird
        mit allen Spieltagen, Spielen und Ergebnissen gelöscht und ersetzt.
      </div>
      <div
        v-if="
          seasonTransferPreview.warnings && seasonTransferPreview.warnings.length
        "
        style="margin-top: 12px"
      >
        <div class="font-bold">
          Hinweise ({{ seasonTransferPreview.warnings.length }}):
        </div>
        <ul style="padding-left: 18px">
          <li
            v-for="(warning, index) in seasonTransferPreview.warnings"
            :key="index"
            style="margin-bottom: 2px"
          >
            {{ warning }}
          </li>
        </ul>
      </div>
    </div>
    <template #footer>
      <Button
        label="Abbrechen"
        icon="pi pi-times"
        class="p-button-text"
        :disabled="transferringToSeason"
        @click="showSeasonTransferDialog = false"
      />
      <Button
        label="Übernehmen"
        icon="pi pi-check"
        :loading="transferringToSeason"
        @click="transferScheduleToSeason"
      />
    </template>
  </Dialog>
  <Dialog v-model:visible="showSeasonTransferResultDialog" :closable="false">
    <template #header>
      <h3>Spielplan übernommen</h3>
    </template>
    <div style="max-width: 640px">
      <p>
        Die Saison <b>{{ seasonTransferResult.seasonName }}</b> wurde
        {{
          seasonTransferResult.replacedExistingSeason ? "ersetzt" : "angelegt"
        }}: {{ seasonTransferResult.leagueCount }} Ligen,
        {{ seasonTransferResult.gameDayCount }} Spieltage,
        {{ seasonTransferResult.gameCount }} Spiele (davon
        {{ seasonTransferResult.byeGameCount }} spielfrei),
        {{ seasonTransferResult.createdTeamCount }} neue und
        {{ seasonTransferResult.updatedTeamCount }} aktualisierte Mannschaften.
      </p>
      <div
        v-if="seasonTransferResult.warnings && seasonTransferResult.warnings.length"
        style="margin-top: 12px"
      >
        <div class="font-bold">
          Hinweise ({{ seasonTransferResult.warnings.length }}):
        </div>
        <ul style="padding-left: 18px">
          <li
            v-for="(warning, index) in seasonTransferResult.warnings"
            :key="index"
            style="margin-bottom: 2px"
          >
            {{ warning }}
          </li>
        </ul>
      </div>
    </div>
    <template #footer>
      <Button
        label="Schließen"
        icon="pi pi-check"
        @click="showSeasonTransferResultDialog = false"
      />
    </template>
  </Dialog>
  <Dialog v-model:visible="showSeasonTransferErrorDialog" :closable="false">
    <template #header>
      <h3>Spielplan nicht übernommen</h3>
    </template>
    <div style="max-width: 620px">{{ seasonTransferError }}</div>
    <template #footer>
      <Button
        label="Schließen"
        icon="pi pi-check"
        @click="showSeasonTransferErrorDialog = false"
      />
    </template>
  </Dialog>
  <Dialog v-model:visible="showCriteriaProblemsDialog" :closable="false">
    <template #header>
      <h3>Spielplan-Erstellung nicht gestartet</h3>
    </template>
    <div style="max-width: 620px">
      <p>
        Diese Wünsche verweisen auf eine Mannschaft, die nicht gefunden wird. Bitte bei der
        jeweiligen Mannschaft korrigieren und danach neu starten:
      </p>
      <ul style="padding-left: 18px">
        <li
          v-for="(problem, index) in criteriaProblems"
          :key="index"
          style="margin-bottom: 4px"
        >
          {{ problem }}
        </li>
      </ul>
    </div>
    <template #footer>
      <Button
        label="Schließen"
        icon="pi pi-check"
        @click="showCriteriaProblemsDialog = false"
      />
    </template>
  </Dialog>
  <Dialog v-model:visible="showDeleteCriteriaDialog" :closable="false">
    <template #header>
      <h3>Bedingung oder Wunsch löschen</h3>
    </template>

    Soll die Bedingung / Wunsch {{ getLabelForCriteriaType(criteriaToDelete.type) }} für
    Mannschaft {{ selectedTeam.name }} wirklich gelöscht werden?

    <template #footer>
      <Button
        label="Löschen"
        icon="pi pi-trash"
        class="p-button-text"
        @click="executeDeleteCriteria"
      />
      <Button label="Abbrechen" icon="pi pi-check" @click="cancelDeleteCriteria" />
    </template>
  </Dialog>
  <PreSeasonTeamEditDialog
    v-model:visible="showTeamEditDialog"
    :teamId="teamToEditId"
    @saved="onTeamSaved"
  />
  <Dialog v-model:visible="showDeleteTeamDialog" modal :closable="!deletingTeam">
    <template #header>
      <h3>Mannschaft löschen</h3>
    </template>
    <div class="flex flex-column">
      Soll die Mannschaft "{{ teamToDelete.name }}" wirklich gelöscht werden? Alle
      Bedingungen / Wünsche der Mannschaft und ihre Zuordnungen zu Ligagruppen und Ligen
      werden dabei ebenfalls entfernt.
    </div>
    <template #footer>
      <div class="flex justify-content-between flex-wrap card-container">
        <Button
          label="Abbrechen"
          severity="secondary"
          :disabled="deletingTeam"
          @click="showDeleteTeamDialog = false"
        />
        <Button
          label="Löschen"
          icon="pi pi-trash"
          class="p-button-danger"
          :loading="deletingTeam"
          :disabled="deletingTeam"
          @click="executeDeleteTeam"
        />
      </div>
    </template>
  </Dialog>
  <Dialog v-model:visible="showShiftGameDayError" :closable="false">
    <template #header>
      <h3>Spieltag nicht verschoben</h3>
    </template>
    <div style="max-width: 520px">{{ shiftGameDayError }}</div>
    <template #footer>
      <Button label="Schließen" icon="pi pi-check" @click="showShiftGameDayError = false" />
    </template>
  </Dialog>
  <Dialog id="gameDayDialog" modal v-model:visible="showGameDayDialog" :closable="true">
    <template #header>
      <div
        class="align-items-center justify-content-center"
        style="font-size: 20px; text-align: center; width: 100%"
      >
        Spieltag verschieben
      </div>
    </template>
    <div class="flex flex-column">
      <div class="flex align-items-center justify-content-center">
        <label>Anderes Datum</label>
      </div>
      <div class="flex">
        <Calendar inline v-model="currentGameDay.dateValue" dateFormat="dd.mm.yy" />
      </div>
      <div class="flex align-items-center justify-content-center">
        <label>Verschoben wegen</label>
      </div>
      <div class="flex align-items-center justify-content-center">
        <InputText v-model="currentGameDay.moveCause" style="width: 100%" />
      </div>
    </div>
    <template #footer>
      <div class="flex justify-content-between flex-wrap card-container">
        <Button label="Abbrechen" @click="closeGameDayDialog(false)" />
        <Button label="Speichern" @click="closeGameDayDialog(true)" />
      </div>
    </template>
  </Dialog>

  <!-- Manueller Liga-Tausch zweier Mannschaften desselben Ligatyps -->
  <Dialog
    v-model:visible="swapDialogVisible"
    modal
    :style="{ width: '680px', maxWidth: '96vw' }"
    header="Liga tauschen"
    @hide="onSwapDialogHide"
  >
    <div v-if="swapSource">
      <div class="mb-3">
        Quell-Mannschaft:
        <b>{{ swapSource.teamName }}</b>
        <span class="text-color-secondary"> ({{ swapSource.leagueName }})</span>
      </div>

      <!-- Heatmap des Ligatyps zur Orientierung; Klick auf einen Punkt wählt das Ziel -->
      <div
        v-if="tierResult && tierResult.heatMapImage"
        style="
          position: relative;
          width: 100%;
          max-width: 420px;
          margin-bottom: 14px;
        "
      >
        <img
          :src="tierResult.heatMapImage"
          style="
            width: 100%;
            height: auto;
            display: block;
            border-radius: 6px;
            border: 1px solid var(--surface-border);
          "
        />
        <template v-if="tierResult.imageWidth > 0">
          <div
            v-for="point in tierResult.heatMapPoints"
            :key="'swap-' + point.teamId"
            class="heatmap-hotspot"
            :style="{
              position: 'absolute',
              left: (point.x / tierResult.imageWidth) * 100 + '%',
              top: (point.y / tierResult.imageHeight) * 100 + '%',
              transform: 'translate(-50%, -50%)',
              width: '18px',
              height: '18px',
              borderRadius: '50%',
              cursor: isSwapPointSelectable(point) ? 'pointer' : 'default',
              border:
                swapTargetId === point.teamId
                  ? '2px solid var(--primary-color)'
                  : point.teamId === swapSource.teamId
                  ? '2px solid var(--yellow-500)'
                  : 'none',
              background:
                swapTargetId === point.teamId
                  ? 'rgba(59,130,246,0.25)'
                  : 'transparent',
            }"
            v-tooltip.top="point.teamName + ' (' + point.leagueName + ')'"
            @click="selectSwapTargetFromPoint(point)"
          />
        </template>
      </div>

      <div class="flex flex-wrap align-items-center gap-2 mb-3">
        <label class="font-bold">Tauschen mit:</label>
        <Dropdown
          v-model="swapTargetId"
          :options="swapCandidates"
          optionLabel="label"
          optionValue="teamId"
          placeholder="Mannschaft wählen"
          filter
          @change="
            swapEvaluation = null;
            swapRepairStatus = null;
          "
          style="min-width: 280px"
        />
        <Button
          label="Auswirkungen prüfen"
          icon="pi pi-search"
          :disabled="!swapTargetId || swapEvaluating"
          @click="evaluateSwap"
        />
        <ProgressSpinner
          v-if="swapEvaluating"
          style="width: 20px; height: 20px"
          strokeWidth="6"
        />
      </div>

      <div v-if="swapEvaluation">
        <div
          v-if="!swapEvaluation.valid"
          class="p-2 border-round"
          style="background: var(--red-100); color: var(--red-900)"
        >
          {{ swapEvaluation.message }}
        </div>
        <template v-else>
          <div
            class="p-2 border-round mb-2 font-bold"
            :style="verdictStyle(swapEvaluation.verdict)"
          >
            {{ verdictLabel(swapEvaluation.verdict) }}
          </div>
          <div class="mb-3">
            <div>
              Harte Verstöße:
              <b>{{ swapEvaluation.hardBefore }}</b>
              →
              <b
                :style="{
                  color:
                    swapEvaluation.hardAfter > 0
                      ? 'var(--red-500)'
                      : 'var(--green-600)',
                }"
                >{{ swapEvaluation.hardAfter }}</b
              >
            </div>
            <div>
              Weiche Strafe (kleiner = besser):
              <b>{{ swapEvaluation.softPenaltyBefore }}</b>
              →
              <b :style="{ color: swapSoftColor(swapEvaluation) }">{{
                swapEvaluation.softPenaltyAfter
              }}</b>
            </div>
          </div>

          <div v-if="swapEvaluation.hardChanges.length" class="mb-3">
            <div class="font-bold mb-1">Änderungen harte Verstöße</div>
            <table style="border-collapse: collapse; width: 100%">
              <tr
                v-for="c in swapEvaluation.hardChanges"
                :key="'h-' + c.name"
              >
                <td :style="swapChangeNameStyle">{{ c.name }}</td>
                <td :style="swapChangeCellStyle">
                  {{ c.before }} → {{ c.after }}
                </td>
                <td :style="swapDeltaStyle(c.delta, true)">
                  {{ deltaLabel(c.delta) }}
                </td>
              </tr>
            </table>
          </div>

          <div v-if="swapEvaluation.softChanges.length" class="mb-2">
            <div class="font-bold mb-1">Änderungen weiche Verstöße</div>
            <table style="border-collapse: collapse; width: 100%">
              <tr
                v-for="c in swapEvaluation.softChanges"
                :key="'s-' + c.name"
              >
                <td :style="swapChangeNameStyle">{{ c.name }}</td>
                <td :style="swapChangeCellStyle">
                  {{ c.before }} → {{ c.after }}
                </td>
                <td :style="swapDeltaStyle(c.delta, isCategoryLowerBetter(c.name))">
                  {{ deltaLabel(c.delta) }}
                </td>
              </tr>
            </table>
          </div>
          <div
            v-if="
              !swapEvaluation.hardChanges.length &&
              !swapEvaluation.softChanges.length
            "
            class="text-color-secondary"
          >
            Keine Änderungen an den Verstößen.
          </div>

          <div
            v-if="swapEvaluation.hardAfter > 0"
            class="mt-3 pt-3"
            style="border-top: 1px solid var(--surface-border)"
          >
            <div class="mb-2 text-color-secondary">
              Dieser Tausch erzeugt harte Verstöße und kann nicht direkt
              übernommen werden. Das Programm kann versuchen, sie automatisch
              aufzulösen – die beiden getauschten Mannschaften bleiben dabei
              fixiert, nur die übrigen werden umgruppiert.
            </div>

            <div
              v-if="swapRepairStatus === 'FAILED'"
              class="p-2 border-round mb-2"
              style="background: var(--red-100); color: var(--red-900)"
            >
              Auch der große Reparaturlauf konnte keine zulässige Lösung finden.
              Der Plan bleibt unverändert.
            </div>
            <div
              v-else-if="swapRepairStatus === 'SMALL_FAILED'"
              class="p-2 border-round mb-2"
              style="background: var(--yellow-100); color: var(--yellow-900)"
            >
              Der kurze Reparaturlauf hat es nicht geschafft. Ein größerer Lauf
              (mehr Zeit, parallele Suche) kann es erneut versuchen.
            </div>

            <div class="flex gap-2">
              <Button
                v-if="
                  swapRepairStatus !== 'SMALL_FAILED' &&
                  swapRepairStatus !== 'FAILED'
                "
                label="Kleinen Reparaturlauf starten"
                icon="pi pi-wrench"
                :loading="swapRepairing"
                :disabled="swapRepairing || swapApplying"
                @click="repairSwap('small')"
              />
              <Button
                v-if="swapRepairStatus === 'SMALL_FAILED'"
                label="Großen Reparaturlauf starten"
                icon="pi pi-cog"
                :loading="swapRepairing"
                :disabled="swapRepairing || swapApplying"
                @click="repairSwap('big')"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
    <template #footer>
      <Button
        label="Abbrechen"
        class="p-button-text"
        @click="closeSwapDialog"
      />
      <Button
        label="Tausch durchführen"
        icon="pi pi-check"
        :disabled="
          !swapEvaluation ||
          !swapEvaluation.valid ||
          !swapEvaluation.applicable ||
          swapApplying
        "
        @click="applySwap"
      />
    </template>
  </Dialog>
</template>

<script>
import ServerConnection from "../../../services/ServerConnection/ServerConnection";
import FailureHandler from "../../../services/ServerConnection/FailureHandler";
import { useMenuService } from "../../../services/MenuService/UseMenuService";
import RecordField from "../../records/RecordField";
import PreSeasonTeamEditDialog from "./PreSeasonTeamEditDialog";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import InputNumber from "primevue/inputnumber";
import Stepper from "primevue/stepper";
import StepperPanel from "primevue/stepperpanel";
import Dropdown from "primevue/dropdown";
import PickList from "primevue/picklist";
import Listbox from "primevue/listbox";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import AutoComplete from "primevue/autocomplete";
import Message from "primevue/message";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext";
import ProgressSpinner from "primevue/progressspinner";
import ProgressBar from "primevue/progressbar";
import Slider from "primevue/slider";
import Checkbox from "primevue/checkbox";
import Tag from "primevue/tag";
export default {
  name: "SeasonScheduler",
  components: {
    Calendar,
    InputNumber,
    Dropdown,
    DataTable,
    Column,
    Dialog,
    Accordion,
    AccordionTab,
    Stepper,
    StepperPanel,
    PickList,
    Listbox,
    Button,
    RecordField,
    PreSeasonTeamEditDialog,
    InputText,
    ProgressSpinner,
    ProgressBar,
    Slider,
    Checkbox,
    Tag,
    AutoComplete,
    Message,
  },
  created() {
    this.updateMenus();
    this.loadSeasons(true);
    this.loadPreSeasonTeamCriteriaFieldDescriptions();
  },
  updated() {
    this.updateMenus();
    this.loadSeasons(false);
    this.loadPreSeasonTeamCriteriaFieldDescriptions();
  },
  data() {
    return {
      savePresSeasonInProgress: false,
      criteriaFieldDescriptionsPreSeasonId: null,
      showAddLeagueTemplateDialog: false,
      addingLeagueTemplate: false,
      addLeagueTemplateError: "",
      newLeagueTemplate: {
        prefix: "",
        numberOfLeagues: 1,
        freeDateChoice: false,
        promotionCount: 0,
        promotionPlayoffCount: 0,
        relegationCount: 0,
      },
      filteredLeagueTemplatePrefixes: [],
      showCriteriaProblemsDialog: false,
      criteriaProblems: [],
      teamsPickListSelection: [[], []],
      teamsPickListSearchTerm: "",
      movingTeams: false,
      assigningByCurrentLeague: false,
      showAssignByLeagueDialog: false,
      assignByLeagueResult: {},
      checkingAssignment: false,
      showCheckAssignmentDialog: false,
      checkAssignmentResult: {},
      loadingSeasonTransferPreview: false,
      showSeasonTransferDialog: false,
      seasonTransferPreview: {},
      transferringToSeason: false,
      showSeasonTransferResultDialog: false,
      seasonTransferResult: {},
      showSeasonTransferErrorDialog: false,
      seasonTransferError: "",
      scheduleReport: null,
      reportCopied: false,
      distancePreparation: null,
      selectedPreSeason: {},
      preSeasons: [],
      savingRegistrationDeadline: false,
      selectedSeason: {},
      seasons: [],
      selectedPreSeasonLeagueTemplate: {},
      preSeasonLeagueTemplates: [],
      teamsPickList: [[], []],
      allTeams: [],
      teamSearchTerm: "",
      showTeamEditDialog: false,
      boardInspectionExportRunning: false,
      teamToEditId: null,
      showDeleteTeamDialog: false,
      teamToDelete: {},
      deletingTeam: false,
      teamFilter: "ALL",
      selectedTeam: {},
      allPreSeasonTeamCriteriaFieldDescriptions: [],
      currentTeamPreSeasonTeamCriteriaFieldDescriptions: [],
      selectedTeamCriteriaFieldDescription: {},
      displayCriteriaDialog: false,
      displayNewSeasonDialog: false,
      displayDeleteSeasonDialog: false,
      currentTeamCriteria: {},
      teamCriterias: [],
      showDeleteCriteriaDialog: false,
      criteriaToDelete: {},
      firstScheduleStart: null,
      secondScheduleStart: null,
      gameDays: [],
      blockedDates: [],
      newBlockedDate: { dateValue: null, reason: "" },
      savingBlockedDates: false,
      shiftingGameDay: false,
      shiftGameDayError: "",
      showShiftGameDayError: false,
      showGameDayDialog: false,
      currentGameDay: {},
      lastStatusTime: Date.now(),
      scheduleCalculationStatus: {},
      softValueMap: {},
      softDeltas: {},
      distanceWeight: 5,
      useBestKnownStart: true,
      bestKnownStart: null,
      applyingBestKnownStart: false,
      continueLoadingCalculationStatus: false,
      resultLeagues: [],
      resultUnfulfilledWishes: [],
      resultTiers: [],
      selectedTier: null,
      tierResult: null,
      loadingTierResult: false,
      selectedHeatMapLocation: null,
      hoveredHeatMapLocation: null,
      swapDialogVisible: false,
      swapSource: null,
      swapTargetId: null,
      swapEvaluation: null,
      swapEvaluating: false,
      swapApplying: false,
      swapRepairing: false,
      swapRepairStatus: null,
      selectedResultLeague: null,
      selectedLeagueResult: null,
      loadingLeagueResult: false,
      expandedRows: {},
    };
  },
  props: {},
  computed: {
    promotionHint() {
      return (
        "Gilt für jede Liga dieser Ligagruppe: Die ersten Plätze steigen direkt auf, die " +
        "darauf folgenden Relegationsplätze spielen um den Aufstieg, die letzten Plätze steigen ab. " +
        "Die Werte gelten für die kommende Saison und werden bei der Übernahme an jede erzeugte " +
        "Liga der Gruppe geschrieben. Einteilung und Prüfung in dieser Vorbereitung richten sich " +
        "dagegen nach der Regelung, die in der Vorsaison für die jeweilige Liga galt."
      );
    },
    bestKnownStartLabel() {
      if (!this.bestKnownStart || !this.bestKnownStart.available) {
        return "";
      }
      var savedAt = this.bestKnownStart.savedAt
        ? new Date(this.bestKnownStart.savedAt).toLocaleString("de-DE")
        : "";
      var quality =
        this.bestKnownStart.hardScore === 0
          ? "zulässig"
          : this.bestKnownStart.hardScore + " harte Verstöße";
      var origin = this.bestKnownStart.manuallyChanged ? ", manuell angepasst" : "";
      return (
        quality +
        ", Strafpunkte " +
        Math.abs(this.bestKnownStart.softScore).toLocaleString("de-DE") +
        " (" +
        savedAt +
        origin +
        ")"
      );
    },
    registrationDeadlineValue: {
      get() {
        if (!this.selectedPreSeason || !this.selectedPreSeason.registrationDeadline) {
          return null;
        }
        var parts = this.selectedPreSeason.registrationDeadline.split("-");
        return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      },
      set(value) {
        this.saveRegistrationDeadline(value);
      },
    },
    registrationDeadlineHint() {
      return (
        "Bis einschließlich zu diesem Tag können Mannschaften gemeldet werden. " +
        "Danach zeigt die Mannschaftsmeldung nur noch den Hinweis, dass die " +
        "Anmeldefrist abgelaufen ist. Ohne Datum bleibt die Meldung offen."
      );
    },
    registrationDeadlineExpired() {
      var deadline = this.registrationDeadlineValue;
      if (!deadline) {
        return false;
      }
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      return deadline.getTime() < today.getTime();
    },
    distancePreparationPercent() {
      var preparation = this.distancePreparation;
      if (!preparation || !preparation.total) {
        return 0;
      }
      return Math.round((preparation.done * 100) / preparation.total);
    },
    assignedTeamCount() {
      return (
        (this.selectedPreSeason && this.selectedPreSeason.preSeasonLeagueTemplates) || []
      ).reduce((sum, template) => sum + ((template.teams && template.teams.length) || 0), 0);
    },
    preSeasonTeamCount() {
      return this.allTeams ? this.allTeams.length : 0;
    },
    assignByLeagueSummary() {
      var byPrefix = this.assignByLeagueResult.assignedByPrefix || {};
      return Object.keys(byPrefix).map((prefix) => prefix + ": " + byPrefix[prefix]);
    },
    filteredTeamsPickList() {
      if (!this.teamsPickList || this.teamsPickList.length < 2) {
        return [[], []];
      }
      var term = (this.teamsPickListSearchTerm || "").trim().toLowerCase();
      if (term.length <= 0) {
        return this.teamsPickList;
      }
      var matches = (teams) =>
        (teams || []).filter((team) => (team.name || "").toLowerCase().indexOf(term) >= 0);
      return [matches(this.teamsPickList[0]), matches(this.teamsPickList[1])];
    },
    moveUpHint() {
      return this.moveHint(-1);
    },
    moveDownHint() {
      return this.moveHint(1);
    },
    // Betriebsart der Spieltermine je Ligatyp: alle spielen an denselben Terminen, unterschiedlich ist nur die Wahl.
    dateChoiceOptions() {
      return [
        { label: "Feste Kalenderwoche (gerade oder ungerade)", value: false },
        { label: "Freie Wahl aus beiden Kalenderwochen", value: true },
      ];
    },
    searchedTeams() {
      var term = this.teamSearchTerm ? this.teamSearchTerm.trim().toLowerCase() : "";
      if (!term) {
        return this.allTeams;
      }
      return this.allTeams.filter(
        (team) => team && team.name && team.name.toLowerCase().includes(term)
      );
    },
    teamsWithCriteria() {
      return this.allTeams.filter(
        (team) => team.numberOfCriterias > 0 || this.hasCriteriaNotes(team)
      );
    },
    teamsWithCriteriaNotes() {
      return this.allTeams.filter((team) => this.hasCriteriaNotes(team));
    },
    teamFilterOptions() {
      return [
        { label: "Alle Mannschaften (" + this.allTeams.length + ")", value: "ALL" },
        {
          label: "Nur mit Wunsch (" + this.teamsWithCriteria.length + ")",
          value: "WITH_CRITERIA",
        },
        {
          label: "Nur mit Freitext (" + this.teamsWithCriteriaNotes.length + ")",
          value: "WITH_NOTES",
        },
      ];
    },
    filteredTeams() {
      if (this.teamFilter === "WITH_CRITERIA") {
        return this.teamsWithCriteria;
      }
      if (this.teamFilter === "WITH_NOTES") {
        return this.teamsWithCriteriaNotes;
      }
      return this.allTeams;
    },
    selectedTeamCriteriaNotes() {
      return this.hasCriteriaNotes(this.selectedTeam)
        ? this.selectedTeam.criteriaNotes.trim()
        : null;
    },
    resultUnfulfilledWishCount() {
      return this.resultUnfulfilledWishes.reduce(
        (total, group) => total + (group.wishes ? group.wishes.length : 0),
        0
      );
    },
    leaguesOfSelectedTier() {
      return this.resultLeagues.filter(
        (league) => league.prefix === this.selectedTier
      );
    },
    tierHeatMapGroups() {
      if (!this.tierResult || !this.tierResult.heatMapPoints) {
        return [];
      }
      var groups = {};
      this.tierResult.heatMapPoints.forEach((point) => {
        var key = point.x + "_" + point.y;
        if (!groups[key]) {
          groups[key] = { key: key, x: point.x, y: point.y, teams: [] };
        }
        groups[key].teams.push({
          teamName: point.teamName,
          leagueName: point.leagueName,
        });
      });
      return Object.values(groups);
    },
    activeHeatMapLocation() {
      // Hover zeigt die Namen sofort; ein angehefteter (geklickter) Punkt bleibt sichtbar, wird aber von einem
      // aktuell überfahrenen Punkt vorübergehend als Vorschau überlagert.
      return this.hoveredHeatMapLocation || this.selectedHeatMapLocation;
    },
    isHeatMapPinned() {
      // Angeheftet = der gerade angezeigte Punkt ist der geklickte (nicht nur ein Hover-Preview eines anderen).
      return (
        this.selectedHeatMapLocation != null &&
        this.activeHeatMapLocation === this.selectedHeatMapLocation
      );
    },
    tierCategories() {
      // Spalten = alle im Tier vorkommenden Kategorien (Reihenfolge wie vom Backend geliefert).
      if (!this.tierResult || !this.tierResult.softViolations) {
        return [];
      }
      return this.tierResult.softViolations.map((sv) => sv.name);
    },
    tierTeamsByLeague() {
      // Mannschaften nach Liga gruppieren (Reihenfolge des Auftretens) inkl. Heatmap-Farbe der Liga.
      if (!this.tierResult || !this.tierResult.softViolationsPerTeam) {
        return [];
      }
      var colorByLeague = {};
      (this.tierResult.leagueColors || []).forEach((c) => {
        colorByLeague[c.leagueId] = c;
      });
      var groups = [];
      var byName = {};
      this.tierResult.softViolationsPerTeam.forEach((team) => {
        if (!byName[team.leagueName]) {
          byName[team.leagueName] = {
            leagueName: team.leagueName,
            color: colorByLeague[team.leagueName] || null,
            teams: [],
          };
          groups.push(byName[team.leagueName]);
        }
        byName[team.leagueName].teams.push(team);
      });
      return groups;
    },
    tierAverageDistance() {
      if (!this.tierResult || !this.tierResult.softViolationsPerTeam) {
        return 0;
      }
      var sum = 0;
      var n = 0;
      this.tierResult.softViolationsPerTeam.forEach((team) => {
        var d = (team.violations || []).find(
          (v) => v.name.indexOf("km") !== -1
        );
        if (d) {
          sum += d.value;
          n++;
        }
      });
      return n ? sum / n : 0;
    },
    averageDistanceRounded() {
      return Math.round(this.tierAverageDistance);
    },
    swapCandidates() {
      // Tauschziele = alle Mannschaften des Ligatyps aus ANDEREN Ligen (gleiche Liga ist kein Liga-Tausch).
      if (!this.tierResult || !this.tierResult.heatMapPoints || !this.swapSource) {
        return [];
      }
      return this.tierResult.heatMapPoints
        .filter(
          (p) =>
            p.teamId !== this.swapSource.teamId &&
            p.leagueName !== this.swapSource.leagueName
        )
        .map((p) => ({
          teamId: p.teamId,
          teamName: p.teamName,
          leagueName: p.leagueName,
          label: p.teamName + " (" + p.leagueName + ")",
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
    },
    swapChangeNameStyle() {
      return {
        textAlign: "left",
        padding: "2px 8px",
        borderBottom: "1px solid var(--surface-border)",
      };
    },
    swapChangeCellStyle() {
      return {
        textAlign: "right",
        padding: "2px 8px",
        borderBottom: "1px solid var(--surface-border)",
        whiteSpace: "nowrap",
      };
    },
  },
  methods: {
    loadBestKnownStart() {
      if (!this.selectedPreSeason || !this.selectedPreSeason.id) {
        this.bestKnownStart = null;
        return;
      }
      ServerConnection.get(
        "preSeason/" + this.selectedPreSeason.id + "/scheduleCalculation/bestKnownStart"
      )
        .then((response) => response.data)
        .then((data) => {
          this.bestKnownStart = data;
        })
        .catch(() => {
          this.bestKnownStart = null;
        });
    },
    applyBestKnownStart() {
      this.applyingBestKnownStart = true;
      ServerConnection.put(
        "preSeason/" +
          this.selectedPreSeason.id +
          "/scheduleCalculation/bestKnownStart/apply"
      )
        .then((response) => {
          if (response.status != 200) {
            return Promise.reject(response);
          }
        })
        .then(() => {
          this.applyingBestKnownStart = false;
          this.resultLeagues = [];
          this.resultUnfulfilledWishes = [];
          this.resultTiers = [];
          this.selectedTier = null;
          this.tierResult = null;
          this.selectedResultLeague = null;
          this.selectedLeagueResult = null;
          this.softValueMap = {};
          this.softDeltas = {};
          this.scheduleReport = null;
          this.continueLoadingCalculationStatus = true;
          this.loadScheduleCalculationStatus();
        })
        .catch((error) => {
          this.applyingBestKnownStart = false;
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    discardBestKnownStart() {
      ServerConnection.delete(
        "preSeason/" + this.selectedPreSeason.id + "/scheduleCalculation/bestKnownStart"
      )
        .then(() => {
          this.bestKnownStart = null;
        })
        .catch((error) => {
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    valueForTeam(team, category) {
      var found = (team.violations || []).find((v) => v.name === category);
      return found ? found.value : "";
    },
    deltaLabel(delta) {
      return (delta > 0 ? "+" : "") + delta;
    },
    deltaStyle(delta) {
      var style = {
        marginLeft: "4px",
        padding: "0 6px",
        borderRadius: "8px",
        fontSize: "0.85em",
      };
      if (delta < 0) {
        style.backgroundColor = "#dcfce7"; // leicht grün: Verringerung (besser)
        style.color = "#166534";
      } else if (delta > 0) {
        style.backgroundColor = "#fee2e2"; // leicht rot: Erhöhung (schlechter)
        style.color = "#991b1b";
      }
      return style;
    },
    weekLabel(weekType) {
      if (weekType === "EVEN") {
        return "Gerade";
      }
      if (weekType === "ODD") {
        return "Ungerade";
      }
      if (weekType === "NO_MATTER") {
        return "Egal";
      }
      return "–";
    },
    softCellStyle(category, team) {
      var base = {
        textAlign: "center",
        padding: "2px 8px",
        borderBottom: "1px solid var(--surface-border)",
      };
      // Nur die Distanz-Spalte wird relativ zum Tier-Durchschnitt eingefärbt.
      if (category.indexOf("km") === -1) {
        return base;
      }
      var value = this.valueForTeam(team, category);
      var avg = this.tierAverageDistance;
      if (value === "" || value === null || !avg) {
        return base;
      }
      var ratio = value / avg;
      var background;
      var color = "#1f2937";
      if (ratio < 0.75) {
        background = "#15803d"; // deutlich darunter -> dunkelgrün
        color = "#ffffff";
      } else if (ratio < 0.9) {
        background = "#86efac"; // leicht darunter -> hellgrün
      } else if (ratio <= 1.1) {
        background = "#fde047"; // um den Durchschnitt -> gelb
      } else if (ratio <= 1.25) {
        background = "#fca5a5"; // leicht darüber -> hellrot
      } else {
        background = "#b91c1c"; // deutlich darüber -> dunkelrot
        color = "#ffffff";
      }
      base.backgroundColor = background;
      base.color = color;
      base.fontWeight = "600";
      return base;
    },
    boardLoadStyle(game) {
      // Auslastung = belegte Boards (Spiele * 2) im Verhältnis zu vorhandenen Boards.
      var boards = game && game.boards ? game.boards : 0;
      var used = (game && game.gamesAtLocationOnDate ? game.gamesAtLocationOnDate : 0) * 2;
      var ratio = boards > 0 ? used / boards : 0;
      var background = "#16a34a"; // grün: unter der Hälfte
      var color = "#ffffff";
      if (ratio >= 1) {
        background = "#dc2626"; // rot: alle Boards belegt
      } else if (ratio >= 0.5) {
        background = "#f59e0b"; // gelb: dazwischen
        color = "#1f2937";
      }
      return {
        backgroundColor: background,
        color: color,
        padding: "2px 8px",
        borderRadius: "10px",
        whiteSpace: "nowrap",
        fontWeight: "600",
      };
    },
    formatNumber(value) {
      if (value === undefined || value === null) {
        return "0";
      }
      return Number(value).toLocaleString("de-DE");
    },
    scheduleStatusLabel(status) {
      if (status === "RUNNING") {
        return "Spielplan wird berechnet …";
      }
      if (status === "CANCELING") {
        return "Berechnung wird abgebrochen …";
      }
      if (status === "CANCELED") {
        return "Berechnung abgebrochen";
      }
      if (status === "FINISHED") {
        return "Berechnung abgeschlossen";
      }
      if (status === "FAILED") {
        return "Berechnung abgebrochen – Fehler";
      }
      return status;
    },
    assignRemainingTeamsByCurrentLeague() {
      if (!this.selectedPreSeason || !this.selectedPreSeason.id) {
        return;
      }
      this.assigningByCurrentLeague = true;
      ServerConnection.put(
        "preSeason/" + this.selectedPreSeason.id + "/leagueTemplates/assignByCurrentLeague"
      )
        .then((response) => response.data)
        .then((data) => {
          this.assigningByCurrentLeague = false;
          this.assignByLeagueResult = data || {};
          this.showAssignByLeagueDialog = true;
          this.loadSeasons(true);
          this.loadUnassignedTeams();
        })
        .catch((error) => {
          this.assigningByCurrentLeague = false;
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    checkTeamAssignmentByCurrentLeague() {
      if (!this.selectedPreSeason || !this.selectedPreSeason.id) {
        return;
      }
      this.checkingAssignment = true;
      ServerConnection.get(
        "preSeason/" + this.selectedPreSeason.id + "/leagueTemplates/checkAssignment"
      )
        .then((response) => response.data)
        .then((data) => {
          this.checkingAssignment = false;
          this.checkAssignmentResult = data || {};
          this.showCheckAssignmentDialog = true;
        })
        .catch((error) => {
          this.checkingAssignment = false;
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    openSeasonTransferDialog() {
      if (!this.selectedPreSeason || !this.selectedPreSeason.id) {
        return;
      }
      this.loadingSeasonTransferPreview = true;
      ServerConnection.get(
        "preSeason/" +
          this.selectedPreSeason.id +
          "/scheduleCalculation/seasonTransferPreview"
      )
        .then((response) => response.data)
        .then((data) => {
          this.loadingSeasonTransferPreview = false;
          this.seasonTransferPreview = data || {};
          this.showSeasonTransferDialog = true;
        })
        .catch((error) => {
          this.loadingSeasonTransferPreview = false;
          this.handleSeasonTransferFailure(error);
        });
    },
    transferScheduleToSeason() {
      if (!this.selectedPreSeason || !this.selectedPreSeason.id) {
        return;
      }
      this.transferringToSeason = true;
      ServerConnection.put(
        "preSeason/" +
          this.selectedPreSeason.id +
          "/scheduleCalculation/transferToSeason"
      )
        .then((response) => response.data)
        .then((data) => {
          this.transferringToSeason = false;
          this.showSeasonTransferDialog = false;
          this.seasonTransferResult = data || {};
          this.showSeasonTransferResultDialog = true;
          this.loadSeasons(true);
        })
        .catch((error) => {
          this.transferringToSeason = false;
          this.showSeasonTransferDialog = false;
          this.handleSeasonTransferFailure(error);
        });
    },
    handleSeasonTransferFailure(error) {
      var status = error.response ? error.response.status : null;
      if (status === 409) {
        this.seasonTransferError = error.response.data;
        this.showSeasonTransferErrorDialog = true;
        return;
      }
      if (status && status !== 401) {
        this.seasonTransferError =
          "Unerwarteter Fehler beim Übernehmen des Spielplans (HTTP " +
          status +
          "). Es wurde nichts gespeichert. Die Ursache steht im Server-Log.";
        this.showSeasonTransferErrorDialog = true;
        return;
      }
      FailureHandler.handleServerFailure(this.$router, error);
    },
    pickListCountLabel(listIndex) {
      var all = (this.teamsPickList && this.teamsPickList[listIndex]) || [];
      var shown = this.filteredTeamsPickList[listIndex] || [];
      return shown.length === all.length ? all.length : shown.length + " von " + all.length;
    },
    movedInPickList(event, toLeagueTemplate) {
      var moved = (event && event.items) || [];
      if (moved.length <= 0) {
        return;
      }
      var movedIds = moved.map((team) => team.id);
      var stays = (teams) => (teams || []).filter((team) => movedIds.indexOf(team.id) < 0);
      var available = stays(this.teamsPickList[0]);
      var inLeagueTemplate = stays(this.teamsPickList[1]);
      if (toLeagueTemplate) {
        inLeagueTemplate = inLeagueTemplate.concat(moved);
      } else {
        available = available.concat(moved);
      }
      this.teamsPickList = [available, inLeagueTemplate];
      this.teamInLeagueTemplateChanged();
    },
    leagueTemplateLadder() {
      return ["OL", "BZO", "BZ", "KBZ", "KL"];
    },
    neighbourLeagueTemplate(direction) {
      if (
        !this.selectedPreSeasonLeagueTemplate ||
        !this.selectedPreSeasonLeagueTemplate.prefix ||
        !this.selectedPreSeason
      ) {
        return null;
      }
      var ladder = this.leagueTemplateLadder();
      var current = ladder.indexOf(this.selectedPreSeasonLeagueTemplate.prefix.toUpperCase());
      if (current < 0) {
        return null;
      }
      var wanted = ladder[current + direction];
      if (!wanted) {
        return null;
      }
      return (this.selectedPreSeason.preSeasonLeagueTemplates || []).find(
        (template) => (template.prefix || "").toUpperCase() === wanted
      );
    },
    selectedTeamsInLeagueTemplate() {
      return (this.teamsPickListSelection && this.teamsPickListSelection[1]) || [];
    },
    canMoveSelectedTeams(direction) {
      return (
        this.selectedTeamsInLeagueTemplate().length > 0 && !!this.neighbourLeagueTemplate(direction)
      );
    },
    moveHint(direction) {
      var wording = direction < 0 ? "höher" : "tiefer";
      if (
        !this.selectedPreSeasonLeagueTemplate ||
        !this.selectedPreSeasonLeagueTemplate.prefix
      ) {
        return "Erst eine Ligagruppe wählen";
      }
      var ladder = this.leagueTemplateLadder();
      if (ladder.indexOf(this.selectedPreSeasonLeagueTemplate.prefix.toUpperCase()) < 0) {
        return (
          "Nur für " +
          ladder.join(", ") +
          " möglich – " +
          this.selectedPreSeasonLeagueTemplate.prefix +
          " gehört nicht zur Spielklassen-Hierarchie"
        );
      }
      var neighbour = this.neighbourLeagueTemplate(direction);
      if (!neighbour) {
        return "Keine Ligagruppe eine Stufe " + wording;
      }
      if (this.selectedTeamsInLeagueTemplate().length <= 0) {
        return "Mannschaften rechts auswählen, dann eine Stufe " + wording + " (" + neighbour.prefix + ")";
      }
      return (
        this.selectedTeamsInLeagueTemplate().length +
        " Mannschaft(en) nach " +
        neighbour.prefix +
        " verschieben"
      );
    },
    moveSelectedTeams(direction) {
      var target = this.neighbourLeagueTemplate(direction);
      var moved = this.selectedTeamsInLeagueTemplate().slice();
      if (!target || moved.length <= 0) {
        return;
      }
      var source = this.selectedPreSeasonLeagueTemplate;
      var movedIds = moved.map((team) => team.id);
      this.movingTeams = true;
      source.teams = (source.teams || []).filter((team) => movedIds.indexOf(team.id) < 0);
      target.teams = (target.teams || []).concat(moved);
      this.saveLeagueTemplateTeams(source)
        .then(() => this.saveLeagueTemplateTeams(target))
        .then(() => {
          this.movingTeams = false;
          this.teamsPickListSelection = [[], []];
          this.teamsPickList[1] = source.teams;
          this.loadSeasons(true);
          this.loadUnassignedTeams();
        })
        .catch((error) => {
          this.movingTeams = false;
          this.loadSeasons(true);
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    saveLeagueTemplateTeams(leagueTemplate) {
      leagueTemplate.preSeason = { id: this.selectedPreSeason.id };
      return ServerConnection.put(
        "data/PreSeasonLeagueTemplate/" + leagueTemplate.id,
        JSON.stringify(leagueTemplate)
      ).then((response) => {
        if (response.status != 200) {
          return Promise.reject(response);
        }
        return response;
      });
    },
    openAddLeagueTemplateDialog() {
      this.newLeagueTemplate = {
        prefix: "",
        numberOfLeagues: 1,
        freeDateChoice: false,
        promotionCount: 0,
        promotionPlayoffCount: 0,
        relegationCount: 0,
      };
      this.addLeagueTemplateError = "";
      this.showAddLeagueTemplateDialog = true;
    },
    filterLeagueTemplatePrefixes(event) {
      var used = (this.selectedPreSeason.preSeasonLeagueTemplates || []).map((t) =>
        (t.prefix || "").toUpperCase()
      );
      var known = ["OL", "BZO", "BZ", "KBZ", "KL"].filter(
        (prefix) => used.indexOf(prefix) < 0
      );
      var query = (event.query || "").trim().toUpperCase();
      this.filteredLeagueTemplatePrefixes =
        query.length === 0
          ? known
          : known.filter((prefix) => prefix.indexOf(query) >= 0);
    },
    closeAddLeagueTemplateDialog(save) {
      if (!save) {
        this.showAddLeagueTemplateDialog = false;
        return;
      }
      var prefix = (this.newLeagueTemplate.prefix || "").trim().toUpperCase();
      if (!/^[A-Z0-9]{1,10}$/.test(prefix)) {
        this.addLeagueTemplateError =
          "Das Kürzel darf nur aus 1 bis 10 Buchstaben oder Ziffern bestehen.";
        return;
      }
      this.addingLeagueTemplate = true;
      this.addLeagueTemplateError = "";
      ServerConnection.post(
        "preSeason/" + this.selectedPreSeason.id + "/leagueTemplate",
        JSON.stringify({
          prefix: prefix,
          numberOfLeagues: this.newLeagueTemplate.numberOfLeagues,
          freeDateChoice: this.newLeagueTemplate.freeDateChoice,
          promotionCount: this.newLeagueTemplate.promotionCount,
          promotionPlayoffCount: this.newLeagueTemplate.promotionPlayoffCount,
          relegationCount: this.newLeagueTemplate.relegationCount,
        })
      )
        .then(() => {
          this.addingLeagueTemplate = false;
          this.showAddLeagueTemplateDialog = false;
          this.loadSeasons(true);
        })
        .catch((error) => {
          this.addingLeagueTemplate = false;
          var status = error.response ? error.response.status : null;
          if (status === 409 || status === 400) {
            this.addLeagueTemplateError = error.response.data;
            return;
          }
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    loadPreSeasonTeamCriteriaFieldDescriptions() {
      var preSeasonId =
        this.selectedPreSeason && this.selectedPreSeason.id ? this.selectedPreSeason.id : null;
      if (
        !this.allPreSeasonTeamCriteriaFieldDescriptions ||
        this.allPreSeasonTeamCriteriaFieldDescriptions.length <= 0 ||
        this.criteriaFieldDescriptionsPreSeasonId !== preSeasonId
      ) {
        this.criteriaFieldDescriptionsPreSeasonId = preSeasonId;
        var preSeasonQuery = preSeasonId ? "?preSeasonId=" + preSeasonId : "";
        ServerConnection.get("preSeasonTeamCriterias/fieldDescriptions" + preSeasonQuery)
          .then((response) => response.data)
          .then((data) => {
            this.allPreSeasonTeamCriteriaFieldDescriptions = data;
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    loadUnassignedTeams() {
      if (this.selectedPreSeason && this.selectedPreSeason.id) {
        ServerConnection.get("unassignedTeams?preSeasonId=" + this.selectedPreSeason.id)
          .then((response) => response.data)
          .then((data) => {
            if (!this.teamsPickList) {
              this.teamsPickList = [[], []];
            }
            this.teamsPickList[0] = data;
            this.teamsPickList[0].sort((t1, t2) => t1.name.localeCompare(t2.name));
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    loadAllTeams() {
      if (this.selectedPreSeason && this.selectedPreSeason.id) {
        ServerConnection.get("allTeams?preSeasonId=" + this.selectedPreSeason.id)
          .then((response) => response.data)
          .then((data) => {
            this.allTeams = data;
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    editTeam(team) {
      if (!team || !team.id) {
        return;
      }
      this.teamToEditId = team.id;
      this.showTeamEditDialog = true;
    },
    exportBoardInspectionList() {
      if (!this.selectedPreSeason || !this.selectedPreSeason.id) {
        return;
      }
      this.boardInspectionExportRunning = true;
      ServerConnection.get(
        "preSeason/" + this.selectedPreSeason.id + "/boardInspectionExport",
        { responseType: "blob" }
      )
        .then((response) => {
          this.boardInspectionExportRunning = false;
          this.saveResponseAsFile(response, "Boardabnahme.xlsx");
        })
        .catch((error) => {
          this.boardInspectionExportRunning = false;
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    saveResponseAsFile(response, fallbackFileName) {
      var url = window.URL.createObjectURL(new Blob([response.data]));
      var link = document.createElement("a");
      link.href = url;
      link.download = this.fileNameOfResponse(response, fallbackFileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    fileNameOfResponse(response, fallbackFileName) {
      var disposition = response.headers
        ? response.headers["content-disposition"]
        : null;
      if (!disposition) {
        return fallbackFileName;
      }
      var match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition);
      return match ? decodeURIComponent(match[1]) : fallbackFileName;
    },
    onTeamSaved() {
      this.loadAllTeams();
      this.loadUnassignedTeams();
      this.loadSeasons(true);
    },
    deleteTeam(team) {
      if (!team || !team.id) {
        return;
      }
      this.teamToDelete = team;
      this.showDeleteTeamDialog = true;
    },
    executeDeleteTeam() {
      if (!this.teamToDelete || !this.teamToDelete.id) {
        this.showDeleteTeamDialog = false;
        return;
      }
      var deletedTeamId = this.teamToDelete.id;
      this.deletingTeam = true;
      ServerConnection.delete("preSeasonTeam/" + deletedTeamId)
        .then((response) => {
          if (response.status != 200) {
            return Promise.reject(response);
          }
        })
        .then(() => {
          this.deletingTeam = false;
          this.showDeleteTeamDialog = false;
          this.teamToDelete = {};
          if (this.selectedTeam && this.selectedTeam.id == deletedTeamId) {
            this.selectedTeam = {};
            this.teamCriterias = [];
          }
          this.loadAllTeams();
          this.loadUnassignedTeams();
          this.loadSeasons(true);
        })
        .catch((error) => {
          this.deletingTeam = false;
          this.showDeleteTeamDialog = false;
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    loadSeasons(forceLoading) {
      if (forceLoading || !this.preSeasons) {
        ServerConnection.get("preSeasons")
          .then((response) => response.data)
          .then((data) => {
            this.preSeasons = data;
            if (this.selectedPreSeason && this.selectedPreSeason.id) {
              this.selectedPreSeason = this.preSeasons.filter(
                (preSeason) => preSeason.id == this.selectedPreSeason.id
              )[0];
            }
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
        ServerConnection.get("seasons")
          .then((response) => response.data)
          .then((data) => {
            this.seasons = data;
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    loadTeamCriterias() {
      if (
        this.selectedPreSeason &&
        this.selectedPreSeason.id &&
        this.selectedTeam &&
        this.selectedTeam.id
      ) {
        ServerConnection.get(
          "preSeasonTeamCriterias/" +
            this.selectedPreSeason.id +
            "/" +
            this.selectedTeam.id
        )
          .then((response) => response.data)
          .then((data) => {
            this.teamCriterias = data;
            this.teamCriterias.forEach((tc) => {
              if (tc.parameters && tc.parameters.length > 0) {
                tc.parameters.split(",").forEach((param) => {
                  var separator = param.indexOf("=");
                  if (separator > 0) {
                    tc[param.substring(0, separator)] = this.decodeParameterValue(
                      param.substring(separator + 1)
                    );
                  }
                });
              }
            });
          })
          .then(() => {
            this.currentTeamPreSeasonTeamCriteriaFieldDescriptions = this.allPreSeasonTeamCriteriaFieldDescriptions.filter(
              (tcfd) => {
                var found = this.teamCriterias.find(
                  (tc) => tc.type == tcfd.type && !tcfd.multipleAllowed
                );
                return !found || found.length <= 0;
              }
            );
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    selectedPreSeasonChanged() {
      this.teamsPickList = [""][""];
      this.allTeams = [];
      this.firstScheduleStart = new Date(this.selectedPreSeason.firstScheduleStart);
      this.secondScheduleStart = new Date(this.selectedPreSeason.secondScheduleStart);
      if (this.firstScheduleStart && this.secondScheduleStart) {
        this.updateScheduleStart(false);
      }
      this.loadUnassignedTeams();
      this.loadAllTeams();
      this.loadBlockedDates();
      this.loadBestKnownStart();
    },
    currentExistingPreSeasonLeagues(prefix) {
      if (
        this.selectedPreSeason &&
        this.selectedPreSeason.preSeasonLeagues &&
        this.selectedPreSeason.preSeasonLeagues.length > 0
      ) {
        return this.selectedPreSeason.preSeasonLeagues.filter(
          (psl) => prefix == psl.prefix
        );
      }
      return [];
    },
    teamInLeagueTemplateChanged() {
      if (
        this.selectedPreSeasonLeagueTemplate &&
        this.selectedPreSeasonLeagueTemplate.id
      ) {
        this.teamsPickList[0].sort((t1, t2) => t1.name.localeCompare(t2.name));
        this.teamsPickList[1].sort((t1, t2) => t1.name.localeCompare(t2.name));
        this.selectedPreSeasonLeagueTemplate.teams = this.teamsPickList[1];
        this.selectedPreSeasonLeagueTemplate.preSeason = {
          id: this.selectedPreSeason.id,
        };
        ServerConnection.put(
          "data/PreSeasonLeagueTemplate/" + this.selectedPreSeasonLeagueTemplate.id,
          JSON.stringify(this.selectedPreSeasonLeagueTemplate)
        )
          .then((response) => {
            if (response.status != 200) {
              return Promise.reject(response);
            }
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    selectedLeagueTemplateChanged() {
      if (!this.teamsPickList) {
        this.teamsPickList = [[], []];
      }
      if (
        this.selectedPreSeasonLeagueTemplate &&
        this.selectedPreSeasonLeagueTemplate.id
      ) {
        this.teamsPickList[1] = this.selectedPreSeasonLeagueTemplate.teams;
        this.teamsPickList[1].sort((t1, t2) => t1.name.localeCompare(t2.name));
      }
    },
    hasCriteriaNotes(team) {
      return !!(team && team.criteriaNotes && team.criteriaNotes.trim().length);
    },
    selectedTeamChanged() {
      this.loadTeamCriterias();
    },
    numberOfLeaguesChanged(preSeasonLeagueTemplate) {
      this.saveLeagueTemplate(preSeasonLeagueTemplate);
    },
    // Erklärung der Betriebsart – als Tooltip am Dropdown, damit sie keinen Platz unter der Auswahl belegt.
    dateChoiceHint(preSeasonLeagueTemplate) {
      if (preSeasonLeagueTemplate.freeDateChoice) {
        return (
          "Die Spielplanerstellung wählt die Spieltage je Liga selbst aus beiden Kalenderwochen – " +
          "je zur Hälfte aus geraden und ungeraden, nie mehr als vier Spielwochen am Stück und " +
          "beginnend unter den ersten vier Terminen des Spielplans. Kalenderwochen-Wünsche der " +
          "Mannschaften greifen in diesem Ligatyp nicht."
        );
      }
      return (
        "Jede Liga spielt entweder in den geraden oder in den ungeraden Kalenderwochen; " +
        "welche, entscheidet die Spielplanerstellung."
      );
    },
    saveLeagueTemplate(preSeasonLeagueTemplate) {
      // Der Server liefert die Ligagruppe innerhalb der PreSeason ohne Rueckreferenz aus (Zyklusvermeidung).
      // Ohne das erneute Setzen verliert die Ligagruppe beim Speichern ihre Saison und verschwindet aus der Maske.
      preSeasonLeagueTemplate.preSeason = { id: this.selectedPreSeason.id };
      ServerConnection.put(
        "data/PreSeasonLeagueTemplate/" + preSeasonLeagueTemplate.id,
        JSON.stringify(preSeasonLeagueTemplate)
      )
        .then((response) => {
          if (response.status != 200) {
            return Promise.reject(response);
          }
        })
        .catch((error) => {
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    addCriteria() {
      this.selectedTeamCriteriaFieldDescription = {};
      this.currentTeamCriteria = {};
      this.displayCriteriaDialog = true;
    },
    selectedTeamCriteriaFieldDescriptionChanged() {
      if (!this.currentTeamCriteria.id) {
        this.currentTeamCriteria.priority = this.selectedTeamCriteriaFieldDescription.defaultPriority;
      }
    },
    closeCriteriaDialog(save) {
      if (
        save &&
        this.selectedTeamCriteriaFieldDescription &&
        this.selectedTeamCriteriaFieldDescription.type
      ) {
        this.currentTeamCriteria.type = this.selectedTeamCriteriaFieldDescription.type;
        var parameters = "";
        this.selectedTeamCriteriaFieldDescription.fieldDescriptions.forEach((fd) => {
          if (
            this.currentTeamCriteria[fd.name] &&
            this.currentTeamCriteria[fd.name].length > 0
          ) {
            if (parameters.length > 0) {
              parameters += ",";
            }
            parameters +=
              fd.name +
              "=" +
              encodeURIComponent(String(this.currentTeamCriteria[fd.name]));
          }
        });
        this.currentTeamCriteria.parameters = parameters;
        if (this.currentTeamCriteria.id) {
          ServerConnection.put(
            "data/preSeasonTeamCriteria/" + this.currentTeamCriteria.id,
            JSON.stringify(this.currentTeamCriteria)
          )
            .then((response) => {
              if (response.status != 200) {
                return Promise.reject(response);
              }
            })
            .then(() => {
              this.currentTeamCriteria = {};
              this.loadTeamCriterias();
            })
            .catch((error) => {
              FailureHandler.handleServerFailure(this.$router, error);
            });
        } else {
          ServerConnection.post(
            "preSeason/" + this.selectedTeam.id + "/preSeasonTeamCriteria",
            JSON.stringify(this.currentTeamCriteria)
          )
            .then((response) => {
              if (response.status != 201) {
                return Promise.reject(response);
              }
            })
            .then(() => {
              this.currentTeamCriteria = {};
              this.loadTeamCriterias();
            })
            .catch((error) => {
              FailureHandler.handleServerFailure(this.$router, error);
            });
        }
      }
      this.displayCriteriaDialog = false;
    },
    getLabelForCriteriaType(criteria) {
      var fieldDescriptions = this.allPreSeasonTeamCriteriaFieldDescriptions.filter(
        (fd) => fd.type == criteria.type
      );
      if (fieldDescriptions && fieldDescriptions.length > 0) {
        return (
          fieldDescriptions[0].label +
          this.getParameterLabelForCriteria(criteria, fieldDescriptions[0])
        );
      }
      return "Unbekannt";
    },
    decodeParameterValue(value) {
      if (value == null || value.indexOf("%") < 0) {
        return value;
      }
      try {
        return decodeURIComponent(value);
      } catch (error) {
        return value;
      }
    },
    getParameterLabelForCriteria(criteria, fieldDescription) {
      var paramLabel = "";
      fieldDescription.fieldDescriptions.forEach((fd) => {
        if (criteria[fd.name] && criteria[fd.name].length > 0) {
          if (fd.fieldType == "Enum") {
            var enumValue = fd.enumValues.find(
              (enumValue) => enumValue.value == criteria[fd.name]
            );
            if (enumValue && enumValue.value) {
              if (paramLabel.length > 0) {
                paramLabel += ", ";
              }
              paramLabel += enumValue.label;
            }
          } else if (fd.fieldType == "Date") {
            var value = new Date(criteria[fd.name]);
            var day = value.getDate();
            var month = value.getMonth() + 1;
            var year = value.getFullYear();
            if (paramLabel.length > 0) {
              paramLabel += ", ";
            }
            paramLabel +=
              (day < 10 ? "0" + day : day) +
              "." +
              (month < 10 ? "0" + month : month) +
              "." +
              year;
          } else {
            if (paramLabel.length > 0) {
              paramLabel += ", ";
            }
            paramLabel += criteria[fd.name];
          }
        }
      });
      if (paramLabel.length > 0) {
        return " (" + paramLabel + ")";
      }
      return paramLabel;
    },
    editCriteria(criteria) {
      var fieldDescriptions = this.allPreSeasonTeamCriteriaFieldDescriptions.filter(
        (fd) => fd.type == criteria.type
      );
      if (fieldDescriptions && fieldDescriptions.length > 0) {
        this.selectedTeamCriteriaFieldDescription = fieldDescriptions[0];
      }
      this.currentTeamCriteria = criteria;
      this.displayCriteriaDialog = true;
    },
    deleteCriteria(criteria) {
      this.criteriaToDelete = criteria;
      this.showDeleteCriteriaDialog = true;
    },
    executeDeleteCriteria() {
      if (this.criteriaToDelete && this.criteriaToDelete.id) {
        ServerConnection.delete(
          "preSeason/" +
            this.selectedTeam.id +
            "/preSeasonTeamCriteria/" +
            this.criteriaToDelete.id
        )
          .then((response) => {
            if (response.status != 200) {
              return Promise.reject(response);
            }
          })
          .then(() => {
            this.loadTeamCriterias();
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
      this.showDeleteCriteriaDialog = false;
    },
    cancelDeleteCriteria() {
      this.showDeleteCriteriaDialog = false;
      this.criteriaToDelete = null;
    },
    updateMenus() {
      const menuService = useMenuService();
      menuService.setSidebarVisisble(false);
      menuService.setMainMenuItemNames(["home"]);
    },
    updateScheduleStart(createNew) {
      var url = "preSeason/" + this.selectedPreSeason.id + "/schedules";

      if (createNew && this.firstScheduleStart && this.secondScheduleStart) {
        url +=
          "?firstScheduleStart=" +
          this.firstScheduleStart.toISOString().split("T")[0] +
          "&secondScheduleStart=" +
          this.secondScheduleStart.toISOString().split("T")[0];
      }
      ServerConnection.get(url)
        .then((response) => response.data)
        .then((data) => {
          this.gameDays = data;
        })
        .catch((error) => {
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    shiftGameDay(gameDay, steps) {
      if (!this.selectedPreSeason || !this.selectedPreSeason.id) {
        return;
      }
      this.shiftingGameDay = true;
      ServerConnection.put(
        "preSeason/" +
          this.selectedPreSeason.id +
          "/gameDay/" +
          gameDay.group +
          "/" +
          gameDay.number +
          "/shift?steps=" +
          steps
      )
        .then((response) => response.data)
        .then((data) => {
          this.shiftingGameDay = false;
          this.gameDays = data;
        })
        .catch((error) => {
          this.shiftingGameDay = false;
          if (error.response && error.response.status === 409) {
            this.shiftGameDayError = error.response.data;
            this.showShiftGameDayError = true;
            return;
          }
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    saveRegistrationDeadline(deadline) {
      if (!this.selectedPreSeason || !this.selectedPreSeason.id) {
        return;
      }
      var isoDate = deadline ? this.toIsoDate(deadline) : "";
      this.savingRegistrationDeadline = true;
      ServerConnection.put(
        "preSeason/" +
          this.selectedPreSeason.id +
          "/registrationDeadline?deadline=" +
          isoDate
      )
        .then(() => {
          this.savingRegistrationDeadline = false;
          this.selectedPreSeason.registrationDeadline = isoDate.length > 0 ? isoDate : null;
        })
        .catch((error) => {
          this.savingRegistrationDeadline = false;
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    toIsoDate(date) {
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return (
        date.getFullYear() +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (day < 10 ? "0" + day : day)
      );
    },
    loadBlockedDates() {
      if (!this.selectedPreSeason || !this.selectedPreSeason.id) {
        this.blockedDates = [];
        return;
      }
      ServerConnection.get("preSeason/" + this.selectedPreSeason.id + "/blockedDates")
        .then((response) => response.data)
        .then((data) => {
          this.blockedDates = data || [];
        })
        .catch((error) => {
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    addBlockedDate() {
      if (!this.newBlockedDate.dateValue) {
        return;
      }
      var isoDate = this.toIsoDate(this.newBlockedDate.dateValue);
      var dates = this.blockedDates
        .filter((blockedDate) => blockedDate.date !== isoDate)
        .map((blockedDate) => ({ date: blockedDate.date, reason: blockedDate.reason }));
      dates.push({ date: isoDate, reason: this.newBlockedDate.reason });
      this.saveBlockedDates(dates, () => {
        this.newBlockedDate = { dateValue: null, reason: "" };
      });
    },
    removeBlockedDate(blockedDate) {
      var dates = this.blockedDates
        .filter((entry) => entry.date !== blockedDate.date)
        .map((entry) => ({ date: entry.date, reason: entry.reason }));
      this.saveBlockedDates(dates, () => {});
    },
    saveBlockedDates(dates, onSaved) {
      this.savingBlockedDates = true;
      ServerConnection.put(
        "preSeason/" + this.selectedPreSeason.id + "/blockedDates",
        JSON.stringify({ dates: dates })
      )
        .then((response) => response.data)
        .then((data) => {
          this.savingBlockedDates = false;
          this.blockedDates = data || [];
          onSaved();
        })
        .catch((error) => {
          this.savingBlockedDates = false;
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    changeGameDay(gameDay) {
      this.currentGameDay = gameDay;
      var dateString = gameDay.date;
      var pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
      this.currentGameDay.dateValue = new Date(dateString.replace(pattern, "$3-$2-$1"));
      this.showGameDayDialog = true;
    },
    closeGameDayDialog(save) {
      if (save) {
        this.currentGameDay.date = new Date(
          this.currentGameDay.dateValue.getTime() + 12 * 60 * 60 * 1000
        );
        ServerConnection.put(
          "preSeason/" +
            this.selectedPreSeason.id +
            "/" +
            this.currentGameDay.group +
            "/gameDay",
          JSON.stringify({
            number: this.currentGameDay.number,
            newDate: this.currentGameDay.date.toISOString().split("T")[0],
            moveCause: this.currentGameDay.moveCause,
          })
        )
          .then((response) => {
            if (response.status != 200) {
              return Promise.reject(response);
            }
          })
          .then(() => {
            this.currentGameDay = {};
            this.updateScheduleStart(false);
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      } else {
        this.currentGameDay = {};
      }
      this.showGameDayDialog = false;
    },
    changeScheduleCalculationStatus(newStatus) {
      var url =
        "preSeason/" +
        this.selectedPreSeason.id +
        "/scheduleCalculation/status?newStatus=" +
        newStatus;
      if (newStatus == "start") {
        url += "&distanceWeightPerKilometer=" + this.distanceWeight;
        url += "&useBestKnownStart=" + (this.useBestKnownStart ? "true" : "false");
      }
      ServerConnection.put(url)
        .then((response) => {
          if (response.status != 200) {
            return Promise.reject(response);
          }
        })
        .then(() => {
          if (newStatus == "start") {
            // Ergebnisse des vorherigen Spielplans entfernen, bis der neue Lauf fertig ist.
            this.resultLeagues = [];
            this.resultUnfulfilledWishes = [];
            this.resultTiers = [];
            this.selectedTier = null;
            this.tierResult = null;
            this.selectedResultLeague = null;
            this.selectedLeagueResult = null;
            this.selectedHeatMapLocation = null;
            this.hoveredHeatMapLocation = null;
            // Δ-Historie der weichen Verstöße für den neuen Lauf zurücksetzen.
            this.softValueMap = {};
            this.softDeltas = {};
            this.scheduleReport = null;
            this.distancePreparation = null;
            this.continueLoadingCalculationStatus = true;
            this.loadScheduleCalculationStatus();
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 409) {
            this.criteriaProblems = error.response.data || [];
            this.showCriteriaProblemsDialog = true;
            return;
          }
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    loadScheduleCalculationStatus() {
      ServerConnection.get(
        "preSeason/scheduleCalculation/status?lastStatusTime=" + this.lastStatusTime
      )
        .then((response) => response.data)
        .then((data) => {
          this.lastStatusTime = Date.now();
          // Veränderung der weichen Verstöße berechnen. Gab es in diesem Poll mindestens eine Änderung, werden die
          // Deltas neu gesetzt (nur geänderte Kategorien bekommen ein Delta, unveränderte keines). Gab es gar keine
          // Änderung, bleiben alle bisher angezeigten Deltas stehen.
          var newMap = {};
          var freshDeltas = {};
          var changed = false;
          (data.softViolations || []).forEach((sv) => {
            newMap[sv.name] = sv.value;
            var previous = this.softValueMap[sv.name];
            if (previous !== undefined && sv.value !== previous) {
              freshDeltas[sv.name] = sv.value - previous;
              changed = true;
            }
          });
          if (changed) {
            this.softDeltas = freshDeltas;
          }
          this.softValueMap = newMap;
          this.scheduleCalculationStatus = data;
          if (data.distancePreparation) {
            this.distancePreparation = data.distancePreparation;
          }
          if (
            this.continueLoadingCalculationStatus &&
            (this.scheduleCalculationStatus.status == "RUNNING" ||
              this.scheduleCalculationStatus.status == "CANCELING")
          ) {
            this.loadScheduleCalculationStatus();
          }
          if (this.scheduleCalculationStatus.status == "FINISHED") {
            this.continueLoadingCalculationStatus = false;
            this.loadResultLeagues();
            this.loadBestKnownStart();
          }
        })
        .catch((error) => {
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    loadResultLeagues() {
      // Nur die leichte Liga-Liste laden; Heatmap/Soft kommen pro Liga-Typ, der Spielplan pro Liga – jeweils einzeln.
      ServerConnection.get("preSeason/scheduleCalculation/result/leagues")
        .then((response) => response.data)
        .then((data) => {
          this.resultLeagues = data || [];
          this.scheduleCalculationStatus = { status: "FINISHED" };
          this.loadResultUnfulfilledWishes();
          this.loadScheduleReport();
          // Liga-Typen (Tiers) in Reihenfolge des Auftretens ableiten.
          var tiers = [];
          this.resultLeagues.forEach((league) => {
            if (tiers.indexOf(league.prefix) === -1) {
              tiers.push(league.prefix);
            }
          });
          this.resultTiers = tiers;
          if (tiers.length) {
            this.selectedTier = tiers[0];
            this.loadTierResult();
            this.selectFirstLeagueOfTier();
          } else {
            this.selectedTier = null;
            this.tierResult = null;
            this.selectedResultLeague = null;
            this.selectedLeagueResult = null;
          }
        })
        .catch((error) => {
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    loadScheduleReport() {
      ServerConnection.get("preSeason/scheduleCalculation/result/report")
        .then((response) => response.data)
        .then((data) => {
          this.scheduleReport = data || null;
          this.reportCopied = false;
        })
        .catch((error) => {
          this.scheduleReport = null;
          if (!error.response || error.response.status !== 404) {
            FailureHandler.handleServerFailure(this.$router, error);
          }
        });
    },
    copyScheduleReport() {
      if (!this.scheduleReport) {
        return;
      }
      var text = this.scheduleReport.plainText;
      var markCopied = () => {
        this.reportCopied = true;
      };
      var fallback = () => {
        try {
          var area = document.createElement("textarea");
          area.value = text;
          area.style.position = "fixed";
          area.style.opacity = "0";
          document.body.appendChild(area);
          area.select();
          document.execCommand("copy");
          document.body.removeChild(area);
          markCopied();
        } catch (e) {
          this.reportCopied = false;
        }
      };
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(markCopied).catch(fallback);
      } else {
        fallback();
      }
    },
    loadResultUnfulfilledWishes() {
      ServerConnection.get("preSeason/scheduleCalculation/result/unfulfilledWishes")
        .then((response) => response.data)
        .then((data) => {
          this.resultUnfulfilledWishes = data || [];
        })
        .catch((error) => {
          this.resultUnfulfilledWishes = [];
          if (!error.response || error.response.status !== 404) {
            FailureHandler.handleServerFailure(this.$router, error);
          }
        });
    },
    onTierChange() {
      this.loadTierResult();
      this.selectFirstLeagueOfTier();
    },
    selectFirstLeagueOfTier() {
      var leagues = this.leaguesOfSelectedTier;
      if (leagues.length) {
        this.selectedResultLeague = leagues[0];
        this.loadResultLeague();
      } else {
        this.selectedResultLeague = null;
        this.selectedLeagueResult = null;
      }
    },
    loadTierResult() {
      if (!this.selectedTier) {
        return;
      }
      this.loadingTierResult = true;
      this.tierResult = null;
      this.selectedHeatMapLocation = null;
      this.hoveredHeatMapLocation = null;
      ServerConnection.get(
        "preSeason/scheduleCalculation/result/tier?prefix=" +
          encodeURIComponent(this.selectedTier)
      )
        .then((response) => response.data)
        .then((data) => {
          this.tierResult = data;
          this.loadingTierResult = false;
        })
        .catch((error) => {
          this.loadingTierResult = false;
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    onResultLeagueChange() {
      this.loadResultLeague();
    },
    openSwapDialog(team) {
      this.swapSource = {
        teamId: team.teamId,
        teamName: team.teamName,
        leagueName: team.leagueName,
      };
      this.swapTargetId = null;
      this.swapEvaluation = null;
      this.swapDialogVisible = true;
    },
    closeSwapDialog() {
      this.swapDialogVisible = false;
    },
    onSwapDialogHide() {
      this.swapSource = null;
      this.swapTargetId = null;
      this.swapEvaluation = null;
      this.swapEvaluating = false;
      this.swapApplying = false;
      this.swapRepairing = false;
      this.swapRepairStatus = null;
    },
    isSwapPointSelectable(point) {
      return (
        this.swapSource &&
        point.teamId !== this.swapSource.teamId &&
        point.leagueName !== this.swapSource.leagueName
      );
    },
    selectSwapTargetFromPoint(point) {
      if (!this.isSwapPointSelectable(point)) {
        return;
      }
      this.swapTargetId = point.teamId;
      this.swapEvaluation = null;
      this.swapRepairStatus = null;
    },
    evaluateSwap() {
      if (!this.swapSource || !this.swapTargetId) {
        return;
      }
      this.swapEvaluating = true;
      this.swapEvaluation = null;
      this.swapRepairStatus = null;
      ServerConnection.get(
        "preSeason/scheduleCalculation/swap/evaluate?teamId1=" +
          this.swapSource.teamId +
          "&teamId2=" +
          this.swapTargetId
      )
        .then((response) => response.data)
        .then((data) => {
          this.swapEvaluation = data;
          this.swapEvaluating = false;
        })
        .catch((error) => {
          this.swapEvaluating = false;
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    applySwap() {
      if (
        !this.swapSource ||
        !this.swapTargetId ||
        !this.swapEvaluation ||
        !this.swapEvaluation.applicable
      ) {
        return;
      }
      this.swapApplying = true;
      ServerConnection.put(
        "preSeason/scheduleCalculation/swap?teamId1=" +
          this.swapSource.teamId +
          "&teamId2=" +
          this.swapTargetId,
        ""
      )
        .then((response) => {
          if (response.status != 200) {
            return Promise.reject(response);
          }
        })
        .then(() => {
          this.swapApplying = false;
          this.closeSwapDialog();
          // Ergebnisansicht neu laden, damit Heatmap, Verstöße und Spielplan den Tausch widerspiegeln.
          this.loadTierResult();
          this.loadResultLeague();
          this.loadResultUnfulfilledWishes();
        })
        .catch((error) => {
          this.swapApplying = false;
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    repairSwap(mode) {
      if (!this.swapSource || !this.swapTargetId) {
        return;
      }
      this.swapRepairing = true;
      ServerConnection.put(
        "preSeason/scheduleCalculation/swap/repair?teamId1=" +
          this.swapSource.teamId +
          "&teamId2=" +
          this.swapTargetId +
          "&mode=" +
          mode,
        ""
      )
        .then((response) => {
          if (response.status != 200) {
            return Promise.reject(response);
          }
          return response.data;
        })
        .then((data) => {
          this.swapRepairing = false;
          const status = data && data.status;
          if (status === "APPLIED") {
            this.swapRepairStatus = null;
            this.closeSwapDialog();
            // Ergebnisansicht neu laden – Heatmap, Verstöße und Spielplan
            // spiegeln den reparierten Plan wider.
            this.loadTierResult();
            this.loadResultLeague();
            this.loadResultUnfulfilledWishes();
          } else {
            // SMALL_FAILED -> großen Lauf anbieten; FAILED -> Endstand.
            this.swapRepairStatus = status;
          }
        })
        .catch((error) => {
          this.swapRepairing = false;
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    verdictLabel(verdict) {
      return (
        {
          IMPROVEMENT: "Verbesserung – der Tausch ist vorteilhaft.",
          WORSE: "Verschlechterung – der Tausch verschlechtert den Plan.",
          NEUTRAL: "Neutral – keine nennenswerte Änderung.",
          HARD_VIOLATION:
            "Nicht durchführbar – der Tausch erzeugt harte Verstöße.",
          INVALID: "Tausch nicht möglich.",
        }[verdict] || verdict
      );
    },
    verdictStyle(verdict) {
      var map = {
        IMPROVEMENT: { background: "var(--green-100)", color: "var(--green-900)" },
        WORSE: { background: "var(--orange-100)", color: "var(--orange-900)" },
        NEUTRAL: { background: "var(--surface-100)", color: "var(--text-color)" },
        HARD_VIOLATION: { background: "var(--red-100)", color: "var(--red-900)" },
        INVALID: { background: "var(--red-100)", color: "var(--red-900)" },
      };
      return map[verdict] || map.NEUTRAL;
    },
    swapSoftColor(evaluation) {
      if (evaluation.softPenaltyAfter < evaluation.softPenaltyBefore) {
        return "var(--green-600)";
      }
      if (evaluation.softPenaltyAfter > evaluation.softPenaltyBefore) {
        return "var(--orange-600)";
      }
      return "var(--text-color)";
    },
    isCategoryLowerBetter() {
      // Alle weichen Kennzahlen sind "kleiner = besser" (km, Anzahl Verstöße, Spreizung).
      return true;
    },
    swapDeltaStyle(delta, lowerBetter) {
      var good = lowerBetter ? delta < 0 : delta > 0;
      var bad = lowerBetter ? delta > 0 : delta < 0;
      return {
        textAlign: "right",
        padding: "2px 8px",
        borderBottom: "1px solid var(--surface-border)",
        whiteSpace: "nowrap",
        fontWeight: "600",
        color: good
          ? "var(--green-600)"
          : bad
          ? "var(--orange-600)"
          : "var(--text-color)",
      };
    },
    loadResultLeague() {
      if (!this.selectedResultLeague || !this.selectedResultLeague.name) {
        return;
      }
      this.loadingLeagueResult = true;
      this.selectedLeagueResult = null;
      ServerConnection.get(
        "preSeason/scheduleCalculation/result/league?name=" +
          encodeURIComponent(this.selectedResultLeague.name)
      )
        .then((response) => response.data)
        .then((data) => {
          this.selectedLeagueResult = data;
          this.loadingLeagueResult = false;
        })
        .catch((error) => {
          this.loadingLeagueResult = false;
          FailureHandler.handleServerFailure(this.$router, error);
        });
    },
    gameDayRowStyle(data) {
      if (data.group == 1) {
        return { background: "lightblue" };
      }
      return { background: "lightgray" };
    },
    openNewSeasonDialog() {
      this.selectedPreSeason = {};
      this.displayNewSeasonDialog = true;
    },
    closeNewSeasonDialog(save) {
      this.displayNewSeasonDialog = false;
      if (save) {
        this.savePresSeasonInProgress = true;
        if (this.selectedSeason && this.selectedSeason.id) {
          this.selectedPreSeason.templateSeasonId = this.selectedSeason.id;
        }
        ServerConnection.put("preSeason", JSON.stringify(this.selectedPreSeason))
          .then((resp) => {
            this.selectedPreSeason = resp.data;
            this.loadSeasons(true);
            this.savePresSeasonInProgress = false;
            this.selectedPreSeasonChanged();
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    openDeleteSeasonDialog() {
      this.displayDeleteSeasonDialog = true;
    },
    closeDeleteSeasonDialog(doDelete) {
      this.displayDeleteSeasonDialog = false;
      if (doDelete) {
        ServerConnection.delete("preSeason/" + this.selectedPreSeason.id)
          .then((response) => {
            if (response.status != 200) {
              return Promise.reject(response);
            }
          })
          .then(() => {
            this.selectedPreSeason = {};
            this.loadSeasons(true);
          })
          .catch((error) => {
            FailureHandler.handleServerFailure(this.$router, error);
          });
      }
    },
    onRowExpand(event) {
      this.expandedRows = [];
      if (this.selectedPreSeason) {
        var preSeasonLeagues = this.selectedPreSeason.preSeasonLeagues.filter(
          (psl) => psl.name == event.data.leagueId
        );
        if (preSeasonLeagues.length == 1) {
          this.expandedRows = {
            teams: [{ name: "123454" }],
          };
        }
      }
    },
  },
};
</script>

<style>
.input-class {
  width: 40px !important;
}

.vuecal--month-view .vuecal__cell-content {
  justify-content: flex-start;
  height: 100%;
  align-items: flex-end;
}

.vuecal--month-view .vuecal__cell-date {
  padding: 4px;
}
.vuecal--month-view .vuecal__no-event {
  display: none;
}
.vuecal__event.one {
  background-color: rgba(253, 156, 66, 0.9);
  border: 1px solid rgb(233, 136, 46);
  color: #fff;
}
.vuecal__event.two {
  background-color: rgba(255, 102, 102, 0.9);
  border: 1px solid rgb(235, 82, 82);
  color: #fff;
}
.heatmap-hotspot {
  position: absolute;
  width: 22px;
  height: 22px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  cursor: pointer;
  background: transparent;
}
.heatmap-hotspot:hover {
  background: rgba(0, 0, 0, 0.12);
  outline: 2px solid var(--primary-color, #3b82f6);
}
.heatmap-popup {
  position: absolute;
  transform: translate(-50%, calc(-100% - 14px));
  background: var(--surface-0, #ffffff);
  color: var(--text-color, #1f2937);
  border: 1px solid var(--surface-border, #d1d5db);
  border-radius: 6px;
  padding: 8px 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
  z-index: 20;
  min-width: 170px;
  max-width: 280px;
  text-align: left;
  font-size: 0.9rem;
}
.league-swatch {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  flex: 0 0 auto;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
.result-line {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
  text-align: left;
}
.result-line i {
  margin-top: 0.15rem;
}
</style>
